// tslint:disable
/**
 * Sistema de formalización
 * Sistema de formalización de una solicitud
 *
 * The version of the OpenAPI document: 1.13.0
 * Contact: roberto.villarejo@comimsa.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Una aceptación de una aclaración.
 * @export
 * @interface AceptacionAclaracion
 */
export interface AceptacionAclaracion {
    /**
     * 
     * @type {string}
     * @memberof AceptacionAclaracion
     */
    comentario?: string;
    /**
     * 
     * @type {Array<PatchDocument>}
     * @memberof AceptacionAclaracion
     */
    modificacion: Array<PatchDocument>;
}
/**
 * Una aclaración de un firmable.
 * @export
 * @interface Aclaracion
 */
export interface Aclaracion {
    /**
     * 
     * @type {string}
     * @memberof Aclaracion
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Aclaracion
     */
    fechaCreacion?: string;
    /**
     * 
     * @type {string}
     * @memberof Aclaracion
     */
    fechaCierre?: string;
    /**
     * Indica si es una aclaración aceptada(true) o no(false). Nulo en caso de que se encuentre activa.
     * @type {boolean}
     * @memberof Aclaracion
     */
    aceptada?: boolean;
    /**
     * 
     * @type {Array<Comentario>}
     * @memberof Aclaracion
     */
    comentarios?: Array<Comentario>;
}
/**
 * Una actividad a realizar en el plan de trabajo.
 * @export
 * @interface Actividad
 */
export interface Actividad {
    /**
     * El tipo de la actividad
     * @type {string}
     * @memberof Actividad
     */
    tipo?: string;
    /**
     * El nombre de la actividad
     * @type {string}
     * @memberof Actividad
     */
    nombre?: string;
    /**
     * La fecha de inicio de la actividad expresado con el ISO 8601
     * @type {string}
     * @memberof Actividad
     */
    fechaInicio?: string;
    /**
     * La fecha de finalización de la actividad expresado con el ISO 8601
     * @type {string}
     * @memberof Actividad
     */
    fechaFin?: string;
    /**
     * La duración de la actividad (fecha de inicio - fecha fin) expresada en ISO 8601.
     * @type {string}
     * @memberof Actividad
     */
    duracion?: string;
    /**
     * El número de la etapa en la que se lleva a cabo la actividad.
     * @type {number}
     * @memberof Actividad
     */
    etapaNumero?: number;
    /**
     * El número del objetivo que ataca esta actividad.
     * @type {number}
     * @memberof Actividad
     */
    objetivoNumero?: number;
    /**
     * Los números de los entregables que produce esta actividad.
     * @type {Array<number>}
     * @memberof Actividad
     */
    entregablesNumero?: Array<number>;
}
/**
 * Datos apoyo economico al participante
 * @export
 * @interface ApoyoEconomico
 */
export interface ApoyoEconomico {
    /**
     * Fecha en que inicia el apoyo económico con formato RFC 3339, section 5.6
     * @type {string}
     * @memberof ApoyoEconomico
     */
    fechaInicio?: string;
    /**
     * Fecha en que inicia el apoyo económico con formato  RFC 3339, section 5.6
     * @type {string}
     * @memberof ApoyoEconomico
     */
    fechaFin?: string;
    /**
     * Monto total asignado.
     * @type {number}
     * @memberof ApoyoEconomico
     */
    montoTotal?: number;
    /**
     * Monto asignado por año
     * @type {number}
     * @memberof ApoyoEconomico
     */
    montoAnual?: number;
    /**
     * Monto otorgado como apoyo único
     * @type {number}
     * @memberof ApoyoEconomico
     */
    montoApoyoUnico?: number;
    /**
     * Clave PNPC
     * @type {string}
     * @memberof ApoyoEconomico
     */
    clavePnpc?: string;
    /**
     * Reniecyt de la institución receptora
     * @type {string}
     * @memberof ApoyoEconomico
     */
    reniecyt?: string;
    /**
     * 
     * @type {CuentaBancaria}
     * @memberof ApoyoEconomico
     */
    cuentaBancaria?: CuentaBancaria;
}
/**
 * Area operativa de conacyt
 * @export
 * @interface Area
 */
export interface Area {
    /**
     * El nombre del area operativa
     * @type {string}
     * @memberof Area
     */
    nombre: string;
    /**
     * La clave única del area operativa
     * @type {string}
     * @memberof Area
     */
    clave: string;
    /**
     * Descripción del área
     * @type {string}
     * @memberof Area
     */
    descripcion?: string;
}
/**
 * Clasificación del firmable
 * @export
 * @enum {string}
 */
export enum ClasificacionFirmable {
    CARTA_ISSSTE = 'CARTA_ISSSTE',
    CAB = 'CAB',
    ANEXO_UNO = 'ANEXO_UNO',
    CAR = 'CAR',
    CONVENIO = 'CONVENIO',
    COMPROBANTE = 'COMPROBANTE',
    INFORME = 'INFORME',
    OFICIO = 'OFICIO',
    RECONOCIMIENTO = 'RECONOCIMIENTO',
    SOLICITUD = 'SOLICITUD'
}

/**
 * Un comentario.
 * @export
 * @interface Comentario
 */
export interface Comentario {
    /**
     * 
     * @type {string}
     * @memberof Comentario
     */
    fecha?: string;
    /**
     * 
     * @type {string}
     * @memberof Comentario
     */
    texto: string;
    /**
     * El correo de usuario que realizó el comentario.
     * @type {string}
     * @memberof Comentario
     */
    creadoPor?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ContextoNotificacion {
    DANGER = 'DANGER',
    INFO = 'INFO',
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING'
}

/**
 * Una convocatoria a la que se le asocian varias solicitudes.
 * @export
 * @interface Convocatoria
 */
export interface Convocatoria {
    /**
     * El nombre de la convocatoria
     * @type {string}
     * @memberof Convocatoria
     */
    nombre: string;
    /**
     * La clave única de la convocatoria
     * @type {string}
     * @memberof Convocatoria
     */
    clave: string;
    /**
     * La descripción de la convocatoria
     * @type {string}
     * @memberof Convocatoria
     */
    descripcion?: string;
    /**
     * Tipo de apoyo otorgado
     * @type {string}
     * @memberof Convocatoria
     */
    tipoApoyo?: string;
    /**
     * País donde se aplica el apoyo
     * @type {string}
     * @memberof Convocatoria
     */
    paisEstancia?: string;
    /**
     * Programa presupuestal del apoyo
     * @type {string}
     * @memberof Convocatoria
     */
    programaPresupuestal?: string;
    /**
     * Fecha en que se publica la convocatoria
     * @type {string}
     * @memberof Convocatoria
     */
    fechaPublicacion?: string;
    /**
     * Objetivos de la convocatoria
     * @type {string}
     * @memberof Convocatoria
     */
    objetivos?: string;
    /**
     * Indica si la convocatoria tiene modalidades
     * @type {boolean}
     * @memberof Convocatoria
     */
    tieneModalidades?: boolean;
    /**
     * Indica si la convocatoria tiene procesos
     * @type {boolean}
     * @memberof Convocatoria
     */
    tieneProcesos?: boolean;
    /**
     * Indica si la convocatoria está acitva para la formalización
     * @type {boolean}
     * @memberof Convocatoria
     */
    activo?: boolean;
    /**
     * 
     * @type {Area}
     * @memberof Convocatoria
     */
    area?: Area;
}
/**
 * El resumen de una convocatoria
 * @export
 * @interface ConvocatoriaBrief
 */
export interface ConvocatoriaBrief {
    /**
     * La clave única de la convocatoria
     * @type {string}
     * @memberof ConvocatoriaBrief
     */
    clave?: string;
    /**
     * El nombre de la convocatoria
     * @type {string}
     * @memberof ConvocatoriaBrief
     */
    nombre?: string;
    /**
     * La descripción de la convocatoria
     * @type {string}
     * @memberof ConvocatoriaBrief
     */
    descripcion?: string;
    /**
     * Indica si la convocatoria tiene modalidades
     * @type {boolean}
     * @memberof ConvocatoriaBrief
     */
    tieneModalidades?: boolean;
    /**
     * Indica si la convocatoria tiene procesos
     * @type {boolean}
     * @memberof ConvocatoriaBrief
     */
    tieneProcesos?: boolean;
    /**
     * Indica si la convocatoria está acitva para la formalización
     * @type {boolean}
     * @memberof ConvocatoriaBrief
     */
    activo?: boolean;
    /**
     * La clave del area a la que pertence la convocatoria
     * @type {string}
     * @memberof ConvocatoriaBrief
     */
    claveArea?: string;
}
/**
 * Una cuenta bancaria.
 * @export
 * @interface CuentaBancaria
 */
export interface CuentaBancaria {
    /**
     * Nombre del banco receptor
     * @type {string}
     * @memberof CuentaBancaria
     */
    banco?: string;
    /**
     * Número de la cuenta bancaria
     * @type {string}
     * @memberof CuentaBancaria
     */
    numero: string;
    /**
     * Indica el estado de validación en ante el banco
     * @type {string}
     * @memberof CuentaBancaria
     */
    estado?: CuentaBancariaEstadoEnum;
    /**
     * En caso que la cuenta esté marcada como _inválida_, la cuasa del rechazo en el banco.
     * @type {string}
     * @memberof CuentaBancaria
     */
    causaRechazo?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CuentaBancariaEstadoEnum {
    PORVALIDAR = 'POR_VALIDAR',
    VALIDA = 'VALIDA',
    INVALIDA = 'INVALIDA'
}

/**
 * Un dependiente económico de un participante
 * @export
 * @interface DependienteEconomico
 */
export interface DependienteEconomico {
    /**
     * La CURP del dependiente económico
     * @type {string}
     * @memberof DependienteEconomico
     */
    curp?: string;
    /**
     * La fecha de nacimiento de la persona expresado con RFC 3339, section 5.6
     * @type {string}
     * @memberof DependienteEconomico
     */
    fechaNacimiento?: string;
    /**
     * El nombre completo de la persona.
     * @type {string}
     * @memberof DependienteEconomico
     */
    nombreCompleto: string;
    /**
     * El parentesco que tiene el dependiente económico con un participante
     * @type {string}
     * @memberof DependienteEconomico
     */
    parentesco: DependienteEconomicoParentescoEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DependienteEconomicoParentescoEnum {
    PADRE = 'PADRE',
    MADRE = 'MADRE',
    HIJO = 'HIJO',
    HIJA = 'HIJA',
    ESPOSO = 'ESPOSO',
    ESPOSA = 'ESPOSA',
    CONYUGE = 'CONYUGE',
    CONCUBINO = 'CONCUBINO',
    CONCUBINA = 'CONCUBINA'
}

/**
 * El desglose financiero.
 * @export
 * @interface DesgloseFinanciero
 */
export interface DesgloseFinanciero {
    /**
     * 
     * @type {Array<Gasto>}
     * @memberof DesgloseFinanciero
     */
    gastos?: Array<Gasto>;
}
/**
 * Un documento
 * @export
 * @interface Documento
 */
export interface Documento {
    /**
     * El contenido del documento codificado en base 64
     * @type {string}
     * @memberof Documento
     */
    contenido?: string;
    /**
     * El tipo MIME del contenido
     * @type {string}
     * @memberof Documento
     */
    mediaType?: string;
}
/**
 * Duración del programa o beca
 * @export
 * @interface DuracionPrograma
 */
export interface DuracionPrograma {
    /**
     * Meses (cantidad fija) que dura el programa o beca
     * @type {number}
     * @memberof DuracionPrograma
     */
    meses?: number;
    /**
     * Meses de meses que puede durar la beca (6, 12, 24, etc)
     * @type {Array<number>}
     * @memberof DuracionPrograma
     */
    opcionesMeses?: Array<number>;
    /**
     * 
     * @type {Rango}
     * @memberof DuracionPrograma
     */
    rango?: Rango;
}
/**
 * Un entregable.
 * @export
 * @interface Entregable
 */
export interface Entregable {
    /**
     * El  número del entregable dentro del plan de trabajo. También indica el orden del entregable.
     * @type {number}
     * @memberof Entregable
     */
    numero?: number;
    /**
     * La descripción del entregable.
     * @type {string}
     * @memberof Entregable
     */
    descripcion?: string;
}
/**
 * Una especialidad (Campo de formación).
 * @export
 * @interface Especialidad
 */
export interface Especialidad {
    /**
     * El nombre de la especialidad
     * @type {string}
     * @memberof Especialidad
     */
    nombre?: string;
    /**
     * El identificador de la área a la que se asocia la especialidad
     * @type {number}
     * @memberof Especialidad
     */
    areaId?: number;
    /**
     * El identificador del campo a la que se asocia la especialidad
     * @type {number}
     * @memberof Especialidad
     */
    campoId?: number;
    /**
     * El identificador de la disciplina a la que se asocia la especialidad
     * @type {number}
     * @memberof Especialidad
     */
    disciplinaId?: number;
    /**
     * El identificador de la subdisciplina a la que se asocia la especialidad
     * @type {number}
     * @memberof Especialidad
     */
    subdisciplinaId?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EstadoFormalizacion {
    POR_FORMALIZAR = 'POR_FORMALIZAR',
    CAPTURAR_DATOS = 'CAPTURAR_DATOS',
    DATOS_CAPTURADOS = 'DATOS_CAPTURADOS',
    DATOS_ERRONEOS = 'DATOS_ERRONEOS',
    VALIDANDO_POR_SOLICITANTE = 'VALIDANDO_POR_SOLICITANTE',
    EN_ACLARACION = 'EN_ACLARACION',
    POR_FIRMAR = 'POR_FIRMAR',
    FIRMADO_POR_SOLICITANTE = 'FIRMADO_POR_SOLICITANTE',
    FIRMADO_POR_CONACYT = 'FIRMADO_POR_CONACYT',
    FIRMADO_POR_ASESOR = 'FIRMADO_POR_ASESOR',
    CANCELADA = 'CANCELADA',
    SUSPENDIDA = 'SUSPENDIDA',
    FORMALIZADA = 'FORMALIZADA',
    FORMALIZADA_OCULTA = 'FORMALIZADA_OCULTA'
}

/**
 * Estatus de la firma
 * @export
 * @enum {string}
 */
export enum EstatusFirma {
    CREADA = 'CREADA',
    VALIDACION_FIRMABLE = 'VALIDACION_FIRMABLE',
    FIRMABLE_VALIDADO = 'FIRMABLE_VALIDADO',
    PROCESO_FIRMA = 'PROCESO_FIRMA',
    FIRMADO = 'FIRMADO',
    VALIDACION_FIRMA = 'VALIDACION_FIRMA',
    FIRMA_VALIDADA = 'FIRMA_VALIDADA',
    ERROR_VALIDACION_FIRMA = 'ERROR_VALIDACION_FIRMA'
}

/**
 * Una etapa de un plan de trabajo.
 * @export
 * @interface Etapa
 */
export interface Etapa {
    /**
     * El nombre de la etapa.
     * @type {string}
     * @memberof Etapa
     */
    nombre?: string;
    /**
     * La descripción de la etapa.
     * @type {string}
     * @memberof Etapa
     */
    descripcion?: string;
    /**
     * La duración de la etapa.
     * @type {string}
     * @memberof Etapa
     */
    duracion?: string;
    /**
     * El número de la etapa. Define el orden de la etapa en el plan de trabajo.
     * @type {number}
     * @memberof Etapa
     */
    numero?: number;
}
/**
 * Una firma de un firmable
 * @export
 * @interface Firma
 */
export interface Firma extends PeticionFirma {
    /**
     * 
     * @type {SujetoInfo}
     * @memberof Firma
     */
    sujetoInfo?: SujetoInfo;
    /**
     * 
     * @type {EstatusFirma}
     * @memberof Firma
     */
    estatusFirma?: EstatusFirma;
}
/**
 * 
 * @export
 * @interface FirmaMultiple
 */
export interface FirmaMultiple {
    /**
     * 
     * @type {SujetoInfo}
     * @memberof FirmaMultiple
     */
    sujetoInfo?: SujetoInfo;
    /**
     * Las peticiones de firma a las que se asocia la información del firmante
     * @type {Array<PeticionFirma>}
     * @memberof FirmaMultiple
     */
    peticiones?: Array<PeticionFirma>;
}
/**
 * Numero de firmas en un estado
 * @export
 * @interface FirmaStatusCount
 */
export interface FirmaStatusCount {
    /**
     * 
     * @type {EstatusFirma}
     * @memberof FirmaStatusCount
     */
    status: EstatusFirma;
    /**
     * Firmas con el estatus
     * @type {number}
     * @memberof FirmaStatusCount
     */
    count: number;
}
/**
 * Un firmable (pueden ser datos o un documento) al que se le adjuntan varias firmas
 * @export
 * @interface Firmable
 */
export interface Firmable {
    /**
     * El identificador del firmable
     * @type {string}
     * @memberof Firmable
     */
    id?: string;
    /**
     * El tipo de firmable
     * @type {string}
     * @memberof Firmable
     */
    tipo?: string;
    /**
     * Los datos a firmar
     * @type {string}
     * @memberof Firmable
     */
    datos?: string;
    /**
     * El tipo MIME del firmable
     * @type {string}
     * @memberof Firmable
     */
    mediaType?: string;
    /**
     * La clave única de la solicitud al que se asocia el firmable
     * @type {string}
     * @memberof Firmable
     */
    solicitudClave?: string;
    /**
     * URL compartido del documento en el DMS
     * @type {string}
     * @memberof Firmable
     */
    dmsShared?: string;
    /**
     * 
     * @type {Documento}
     * @memberof Firmable
     */
    representacionImpresa?: Documento;
}
/**
 * El resumen de la información de un Firmable.
 * @export
 * @interface FirmableBrief
 */
export interface FirmableBrief {
    /**
     * El identificador del firmable
     * @type {string}
     * @memberof FirmableBrief
     */
    id?: string;
    /**
     * El tipo de firmable
     * @type {string}
     * @memberof FirmableBrief
     */
    tipo?: string;
}
/**
 * Un gasto relacionado al apoyo
 * @export
 * @interface Gasto
 */
export interface Gasto {
    /**
     * El importe del gasto
     * @type {number}
     * @memberof Gasto
     */
    importe?: number;
    /**
     * La justificación del gasto
     * @type {string}
     * @memberof Gasto
     */
    justificacion?: string;
    /**
     * El tipo de gasto
     * @type {string}
     * @memberof Gasto
     */
    tipoGasto?: string;
    /**
     * El rubro del gasto
     * @type {string}
     * @memberof Gasto
     */
    rubro?: string;
    /**
     * El número de RENIECYT de la persona moral responsable
     * @type {string}
     * @memberof Gasto
     */
    responsableReniecyt?: string;
    /**
     * El número de la etapa en que se lleva a cabo el gasto
     * @type {number}
     * @memberof Gasto
     */
    etapaNumero?: number;
}
/**
 * Una meta.
 * @export
 * @interface Meta
 */
export interface Meta {
    /**
     * El  número de la meta dentro del plan de trabajo. También indica el orden de la meta.
     * @type {number}
     * @memberof Meta
     */
    numero?: number;
    /**
     * La descripción de la meta.
     * @type {string}
     * @memberof Meta
     */
    descripcion?: string;
    /**
     * El número de la etapa a la que pertenece la meta.
     * @type {number}
     * @memberof Meta
     */
    etapaNumero?: number;
}
/**
 * Una modalidad de una convocatoria
 * @export
 * @interface Modalidad
 */
export interface Modalidad {
    /**
     * La clave única de la modalidad
     * @type {string}
     * @memberof Modalidad
     */
    clave: string;
    /**
     * El nombre de la modalidad
     * @type {string}
     * @memberof Modalidad
     */
    nombre: string;
    /**
     * La descripción de la modalidad
     * @type {string}
     * @memberof Modalidad
     */
    descripcion?: string;
    /**
     * Duración de la modalidad
     * @type {number}
     * @memberof Modalidad
     */
    duracion?: number;
    /**
     * 
     * @type {DuracionPrograma}
     * @memberof Modalidad
     */
    duracionPrograma?: DuracionPrograma;
    /**
     * Cantidad de etapas de la modalidad
     * @type {number}
     * @memberof Modalidad
     */
    numeroEtapas?: number;
    /**
     * Fecha de inicio del registro de la modalidad
     * @type {string}
     * @memberof Modalidad
     */
    fechaInicio?: string;
    /**
     * Fecha de finalización del registro de la modalidad
     * @type {string}
     * @memberof Modalidad
     */
    fechaFin?: string;
    /**
     * Fechas de inicio para las estancias
     * @type {Array<string>}
     * @memberof Modalidad
     */
    fechasInicio?: Array<string>;
    /**
     * La clave única de la convocatoria a la que pertenece la modalidad
     * @type {string}
     * @memberof Modalidad
     */
    convocatoriaClave?: string;
    /**
     * Versión del documento
     * @type {string}
     * @memberof Modalidad
     */
    versionId?: string;
}
/**
 * Una notificación del sistema
 * @export
 * @interface Notificacion
 */
export interface Notificacion {
    /**
     * El identificador de la notificación
     * @type {string}
     * @memberof Notificacion
     */
    id: string;
    /**
     * Fecha en la que se creó la notificación
     * @type {string}
     * @memberof Notificacion
     */
    fechaNotificacion: string;
    /**
     * El CVU de la persona notificada
     * @type {string}
     * @memberof Notificacion
     */
    numCvu?: string;
    /**
     * Título de la notificación
     * @type {string}
     * @memberof Notificacion
     */
    titulo?: string;
    /**
     * Texto del cuerpo de la notificación
     * @type {string}
     * @memberof Notificacion
     */
    mensaje: string;
    /**
     * Indica si la notificación fue leída
     * @type {boolean}
     * @memberof Notificacion
     */
    leido?: boolean;
    /**
     * Clave del proyecto al que está relacionada la notificación
     * @type {string}
     * @memberof Notificacion
     */
    claveProyecto?: string;
    /**
     * 
     * @type {ContextoNotificacion}
     * @memberof Notificacion
     */
    contexto: ContextoNotificacion;
    /**
     * 
     * @type {TipoNotificacion}
     * @memberof Notificacion
     */
    tipo: TipoNotificacion;
}
/**
 * Un objetivo.
 * @export
 * @interface Objetivo
 */
export interface Objetivo {
    /**
     * El  número del objetivo dentro del plan de trabajo. También indica el orden del objetivo.
     * @type {number}
     * @memberof Objetivo
     */
    numero?: number;
    /**
     * La descripción del objetivo.
     * @type {string}
     * @memberof Objetivo
     */
    descripcion?: string;
}
/**
 * Una participación de una persona o institución.
 * @export
 * @interface Participacion
 */
export interface Participacion {
    /**
     * 
     * @type {RolPersona}
     * @memberof Participacion
     */
    rolPersona: RolPersona;
    /**
     * El CVU de la persona física que participa
     * @type {string}
     * @memberof Participacion
     */
    participanteCvu: string;
    /**
     * La clave RENIECYT de la persona moral que participa. Debe enviarse en nulo si se usa la institucionClave.
     * @type {string}
     * @memberof Participacion
     */
    personaMoralReniecyt?: string;
    /**
     * La clave de la institución que participa. Debe enviarse en nulo si se usa la personaMoralReniecyt.
     * @type {string}
     * @memberof Participacion
     */
    institucionClave?: string;
    /**
     * El rol con el que participa la institución o la persona moral.
     * @type {string}
     * @memberof Participacion
     */
    rolInstitucion?: ParticipacionRolInstitucionEnum;
    /**
     * Los dependientes económicos asociados a esta participación.
     * @type {Array<DependienteEconomico>}
     * @memberof Participacion
     */
    dependientesEconomicos?: Array<DependienteEconomico>;
    /**
     * 
     * @type {ApoyoEconomico}
     * @memberof Participacion
     */
    apoyoEconomico?: ApoyoEconomico;
}

/**
    * @export
    * @enum {string}
    */
export enum ParticipacionRolInstitucionEnum {
    SUJETO_APOYO = 'SUJETO_APOYO',
    CORRESPONSABLE = 'CORRESPONSABLE',
    PARTICIPANTE = 'PARTICIPANTE'
}

/**
 * Numero de participaciones en todas las solicitudes
 * @export
 * @interface ParticipacionCount
 */
export interface ParticipacionCount {
    /**
     * 
     * @type {RolPersona}
     * @memberof ParticipacionCount
     */
    rolPersona?: RolPersona;
    /**
     * Numero de participaciones de la persona
     * @type {number}
     * @memberof ParticipacionCount
     */
    numero?: number;
}
/**
 * A JSONPatch document as defined by RFC 6902
 * @export
 * @interface PatchDocument
 */
export interface PatchDocument {
    /**
     * The operation to be performed
     * @type {string}
     * @memberof PatchDocument
     */
    op: PatchDocumentOpEnum;
    /**
     * A JSON-Pointer
     * @type {string}
     * @memberof PatchDocument
     */
    path: string;
    /**
     * The value to be used within the operations.
     * @type {object}
     * @memberof PatchDocument
     */
    value?: object;
    /**
     * A string containing a JSON Pointer value.
     * @type {string}
     * @memberof PatchDocument
     */
    from?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PatchDocumentOpEnum {
    Add = 'add',
    Remove = 'remove',
    Replace = 'replace',
    Move = 'move',
    Copy = 'copy',
    Test = 'test'
}

/**
 * Una petición de una firma
 * @export
 * @interface PeticionFirma
 */
export interface PeticionFirma {
    /**
     * El identificador del firmable
     * @type {string}
     * @memberof PeticionFirma
     */
    firmableId: string;
    /**
     * La cadena original a firmar
     * @type {string}
     * @memberof PeticionFirma
     */
    data?: string;
    /**
     * La firma digital
     * @type {string}
     * @memberof PeticionFirma
     */
    firma: string;
    /**
     * 
     * @type {TipoFirma}
     * @memberof PeticionFirma
     */
    tipoFirma?: TipoFirma;
}
/**
 * El plan de trabajo.
 * @export
 * @interface PlanTrabajo
 */
export interface PlanTrabajo {
    /**
     * 
     * @type {Array<Actividad>}
     * @memberof PlanTrabajo
     */
    actividades?: Array<Actividad>;
    /**
     * 
     * @type {Array<Objetivo>}
     * @memberof PlanTrabajo
     */
    objetivos?: Array<Objetivo>;
    /**
     * 
     * @type {Array<Meta>}
     * @memberof PlanTrabajo
     */
    metas?: Array<Meta>;
    /**
     * 
     * @type {Array<Entregable>}
     * @memberof PlanTrabajo
     */
    entregables?: Array<Entregable>;
    /**
     * 
     * @type {Array<Etapa>}
     * @memberof PlanTrabajo
     */
    etapas?: Array<Etapa>;
}
/**
 * Un proceso de una convocatoria
 * @export
 * @interface Proceso
 */
export interface Proceso {
    /**
     * La clave única de el proceso
     * @type {string}
     * @memberof Proceso
     */
    clave: string;
    /**
     * El nombre de el proceso
     * @type {string}
     * @memberof Proceso
     */
    nombre: string;
    /**
     * La descripción de el proceso
     * @type {string}
     * @memberof Proceso
     */
    descripcion?: string;
    /**
     * La clave única de la convocatoria a la que pertenece el proceso
     * @type {string}
     * @memberof Proceso
     */
    convocatoriaClave?: string;
}
/**
 * Define un rango numérico
 * @export
 * @interface Rango
 */
export interface Rango {
    /**
     * Inicio del rango
     * @type {number}
     * @memberof Rango
     */
    inicio?: number;
    /**
     * Fin del rango
     * @type {number}
     * @memberof Rango
     */
    fin?: number;
}
/**
 * El rol con el que participa la persona física
 * @export
 * @enum {string}
 */
export enum RolPersona {
    SOLICITANTE = 'SOLICITANTE',
    AYUDANTE = 'AYUDANTE',
    AUTORIDAD_FACULTADA_EXTERNA = 'AUTORIDAD_FACULTADA_EXTERNA',
    ASPIRANTE = 'ASPIRANTE',
    ASISTIDO = 'ASISTIDO',
    RESPONSABLE_ADMINISTRATIVO = 'RESPONSABLE_ADMINISTRATIVO',
    REPRESENTANTE_LEGAL = 'REPRESENTANTE_LEGAL',
    CORRESPONSABLE_TECNICO = 'CORRESPONSABLE_TECNICO',
    CORRESPONSABLE_ADMINISTRATIVO = 'CORRESPONSABLE_ADMINISTRATIVO',
    CO_REPRESENTANTE_LEGAL = 'CO_REPRESENTANTE_LEGAL',
    CORREPRESENTANTE_LEGAL = 'CORREPRESENTANTE_LEGAL',
    CORRESPONSABLE_PROYECTO = 'CORRESPONSABLE_PROYECTO',
    COASISTIDO = 'COASISTIDO',
    PARTICIPANTE = 'PARTICIPANTE',
    ASESOR_ACADEMICO = 'ASESOR_ACADEMICO',
    ASESOR_PROYECTO = 'ASESOR_PROYECTO',
    RESPONSABLE_PROYECTO = 'RESPONSABLE_PROYECTO',
    RESPONSABLE_TECNICO = 'RESPONSABLE_TECNICO'
}

/**
 * Datos extras del solicitante que no se tienen en algún otro servicio.
 * @export
 * @interface SolicitanteComplemento
 */
export interface SolicitanteComplemento {
    /**
     * CVU del solicitante
     * @type {string}
     * @memberof SolicitanteComplemento
     */
    cvu: string;
    /**
     * Indica si pertenece es parte del programa Investigadores por México
     * @type {boolean}
     * @memberof SolicitanteComplemento
     */
    invxMex?: boolean;
}
/**
 * Una solicitud.
 * @export
 * @interface Solicitud
 */
export interface Solicitud {
    /**
     * El número o id que tiene la solicitud dentro de la convocatoria.
     * @type {string}
     * @memberof Solicitud
     */
    numero: string;
    /**
     * La fecha en que se recibió la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    fechaEnvio?: string;
    /**
     * La clave única de la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    clave: string;
    /**
     * El título.
     * @type {string}
     * @memberof Solicitud
     */
    titulo?: string;
    /**
     * La fecha de inicio del apoyo.
     * @type {string}
     * @memberof Solicitud
     */
    fechaInicio?: string;
    /**
     * La fecha de finalización del apoyo.
     * @type {string}
     * @memberof Solicitud
     */
    fechaFin?: string;
    /**
     * La clave única de la modalidad a la que pertenece el apoyo.
     * @type {string}
     * @memberof Solicitud
     */
    modalidadClave?: string;
    /**
     * La clave única de la proceso a la que pertenece el apoyo.
     * @type {string}
     * @memberof Solicitud
     */
    procesoClave?: string;
    /**
     * 
     * @type {number}
     * @memberof Solicitud
     */
    montoTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof Solicitud
     */
    montoMovilidad?: number;
    /**
     * 
     * @type {PlanTrabajo}
     * @memberof Solicitud
     */
    planTrabajo?: PlanTrabajo;
    /**
     * Las participaciones del apoyo.
     * @type {Array<Participacion>}
     * @memberof Solicitud
     */
    participaciones: Array<Participacion>;
    /**
     * Las especialidades (campos de formación).
     * @type {Array<Especialidad>}
     * @memberof Solicitud
     */
    especialidades?: Array<Especialidad>;
    /**
     * 
     * @type {DesgloseFinanciero}
     * @memberof Solicitud
     */
    desgloseFinanciero?: DesgloseFinanciero;
    /**
     * 
     * @type {EstadoFormalizacion}
     * @memberof Solicitud
     */
    estadoFormalizacion?: EstadoFormalizacion;
}
/**
 * El resumen de la información de una Solicitud. Útil para crear bandejas.
 * @export
 * @interface SolicitudBrief
 */
export interface SolicitudBrief {
    /**
     * La clave única de la solicitud.
     * @type {string}
     * @memberof SolicitudBrief
     */
    clave?: string;
    /**
     * Número de solicitud, compuesta por ID de modalidad y ID de la solicitud (en la evaluacion)
     * @type {string}
     * @memberof SolicitudBrief
     */
    numSolicitud?: string;
    /**
     * El número o id que tiene la solicitud dentro de la convocatoria.
     * @type {string}
     * @memberof SolicitudBrief
     */
    numero?: string;
    /**
     * La clave única de la convocatoria.
     * @type {string}
     * @memberof SolicitudBrief
     */
    convocatoriaClave?: string;
    /**
     * El título.
     * @type {string}
     * @memberof SolicitudBrief
     */
    titulo?: string;
    /**
     * La fecha en que se recibió la solicitud.
     * @type {string}
     * @memberof SolicitudBrief
     */
    fechaEnvio?: string;
    /**
     * La clave única de la modalidad.
     * @type {string}
     * @memberof SolicitudBrief
     */
    modalidadClave?: string;
    /**
     * La clave única de la proceso a la que pertenece el apoyo.
     * @type {string}
     * @memberof SolicitudBrief
     */
    procesoClave?: string;
    /**
     * La clave del solicitante.
     * @type {string}
     * @memberof SolicitudBrief
     */
    solicitanteClave?: string;
    /**
     * El nombre del institucion.
     * @type {string}
     * @memberof SolicitudBrief
     */
    institucionClave?: string;
    /**
     * 
     * @type {RolPersona}
     * @memberof SolicitudBrief
     */
    rolPersona?: RolPersona;
    /**
     * 
     * @type {EstadoFormalizacion}
     * @memberof SolicitudBrief
     */
    estadoFormalizacion?: EstadoFormalizacion;
}
/**
 * La información del firmante
 * @export
 * @interface SujetoInfo
 */
export interface SujetoInfo {
    /**
     * El certificado del sujeto en formato PEM
     * @type {string}
     * @memberof SujetoInfo
     */
    certificado?: string;
    /**
     * La CURP del firmante
     * @type {string}
     * @memberof SujetoInfo
     */
    curp?: string;
    /**
     * El RFC del firmante
     * @type {string}
     * @memberof SujetoInfo
     */
    rfc?: string;
}
/**
 * Tipo de la firma
 * @export
 * @enum {string}
 */
export enum TipoFirma {
    SAT = 'SAT',
    CURP = 'CURP'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum TipoNotificacion {
    CAMBIO_ESTATUS = 'CAMBIO_ESTATUS',
    ERROR_FIRMA = 'ERROR_FIRMA',
    GENERAL = 'GENERAL'
}


/**
 * ConvocatoriaApi - axios parameter creator
 * @export
 */
export const ConvocatoriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de convocatorias
         * @summary Obtiene una página de convocatorias
         * @param {string} [areaClave] Clave del area
         * @param {boolean} [activo] Indica si la convocatoria está acitva o no
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConvocatorias: async (areaClave?: string, activo?: boolean, page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/convocatorias`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (areaClave !== undefined) {
                localVarQueryParameter['areaClave'] = areaClave;
            }

            if (activo !== undefined) {
                localVarQueryParameter['activo'] = activo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la convocatoria con la clave especificada
         * @summary Obtiene la convocatoria con la clave especificada
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvocatoria: async (convocatoriaClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling getConvocatoria.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
         * @summary Obtiene las cuentas bancarias por validar.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentasBancarias: async (convocatoriaClave: string, estado: 'por-validar', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling getCuentasBancarias.');
            }
            // verify required parameter 'estado' is not null or undefined
            if (estado === null || estado === undefined) {
                throw new RequiredError('estado','Required parameter estado was null or undefined when calling getCuentasBancarias.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}/cuentas-bancarias`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (estado !== undefined) {
                localVarQueryParameter['estado'] = estado;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la cantidad de documentos para la convocatoria
         * @summary Obtiene la cantidad de documentos para la convocatoria
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumDocumentosConvocatoria: async (convocatoriaClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling getNumDocumentosConvocatoria.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}/num-documentos`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadValidacionCuentasBancarias: async (convocatoriaClave: string, body: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling loadValidacionCuentasBancarias.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadValidacionCuentasBancarias.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}/cuentas-bancarias`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/octet-stream';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConvocatoriaApi - functional programming interface
 * @export
 */
export const ConvocatoriaApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de convocatorias
         * @summary Obtiene una página de convocatorias
         * @param {string} [areaClave] Clave del area
         * @param {boolean} [activo] Indica si la convocatoria está acitva o no
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConvocatorias(areaClave?: string, activo?: boolean, page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConvocatoriaBrief>>> {
            const localVarAxiosArgs = await ConvocatoriaApiAxiosParamCreator(configuration).getAllConvocatorias(areaClave, activo, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la convocatoria con la clave especificada
         * @summary Obtiene la convocatoria con la clave especificada
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConvocatoria(convocatoriaClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Convocatoria>> {
            const localVarAxiosArgs = await ConvocatoriaApiAxiosParamCreator(configuration).getConvocatoria(convocatoriaClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
         * @summary Obtiene las cuentas bancarias por validar.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCuentasBancarias(convocatoriaClave: string, estado: 'por-validar', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ConvocatoriaApiAxiosParamCreator(configuration).getCuentasBancarias(convocatoriaClave, estado, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la cantidad de documentos para la convocatoria
         * @summary Obtiene la cantidad de documentos para la convocatoria
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumDocumentosConvocatoria(convocatoriaClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await ConvocatoriaApiAxiosParamCreator(configuration).getNumDocumentosConvocatoria(convocatoriaClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadValidacionCuentasBancarias(convocatoriaClave: string, body: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ConvocatoriaApiAxiosParamCreator(configuration).loadValidacionCuentasBancarias(convocatoriaClave, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConvocatoriaApi - factory interface
 * @export
 */
export const ConvocatoriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtiene una página de convocatorias
         * @summary Obtiene una página de convocatorias
         * @param {string} [areaClave] Clave del area
         * @param {boolean} [activo] Indica si la convocatoria está acitva o no
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConvocatorias(areaClave?: string, activo?: boolean, page?: number, size?: number, options?: any): AxiosPromise<Array<ConvocatoriaBrief>> {
            return ConvocatoriaApiFp(configuration).getAllConvocatorias(areaClave, activo, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la convocatoria con la clave especificada
         * @summary Obtiene la convocatoria con la clave especificada
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvocatoria(convocatoriaClave: string, options?: any): AxiosPromise<Convocatoria> {
            return ConvocatoriaApiFp(configuration).getConvocatoria(convocatoriaClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
         * @summary Obtiene las cuentas bancarias por validar.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentasBancarias(convocatoriaClave: string, estado: 'por-validar', options?: any): AxiosPromise<string> {
            return ConvocatoriaApiFp(configuration).getCuentasBancarias(convocatoriaClave, estado, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la cantidad de documentos para la convocatoria
         * @summary Obtiene la cantidad de documentos para la convocatoria
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumDocumentosConvocatoria(convocatoriaClave: string, options?: any): AxiosPromise<number> {
            return ConvocatoriaApiFp(configuration).getNumDocumentosConvocatoria(convocatoriaClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadValidacionCuentasBancarias(convocatoriaClave: string, body: any, options?: any): AxiosPromise<void> {
            return ConvocatoriaApiFp(configuration).loadValidacionCuentasBancarias(convocatoriaClave, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConvocatoriaApi - object-oriented interface
 * @export
 * @class ConvocatoriaApi
 * @extends {BaseAPI}
 */
export class ConvocatoriaApi extends BaseAPI {
    /**
     * Obtiene una página de convocatorias
     * @summary Obtiene una página de convocatorias
     * @param {string} [areaClave] Clave del area
     * @param {boolean} [activo] Indica si la convocatoria está acitva o no
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriaApi
     */
    public getAllConvocatorias(areaClave?: string, activo?: boolean, page?: number, size?: number, options?: any) {
        return ConvocatoriaApiFp(this.configuration).getAllConvocatorias(areaClave, activo, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la convocatoria con la clave especificada
     * @summary Obtiene la convocatoria con la clave especificada
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriaApi
     */
    public getConvocatoria(convocatoriaClave: string, options?: any) {
        return ConvocatoriaApiFp(this.configuration).getConvocatoria(convocatoriaClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
     * @summary Obtiene las cuentas bancarias por validar.
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
     * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriaApi
     */
    public getCuentasBancarias(convocatoriaClave: string, estado: 'por-validar', options?: any) {
        return ConvocatoriaApiFp(this.configuration).getCuentasBancarias(convocatoriaClave, estado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la cantidad de documentos para la convocatoria
     * @summary Obtiene la cantidad de documentos para la convocatoria
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriaApi
     */
    public getNumDocumentosConvocatoria(convocatoriaClave: string, options?: any) {
        return ConvocatoriaApiFp(this.configuration).getNumDocumentosConvocatoria(convocatoriaClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
     * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
     * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriaApi
     */
    public loadValidacionCuentasBancarias(convocatoriaClave: string, body: any, options?: any) {
        return ConvocatoriaApiFp(this.configuration).loadValidacionCuentasBancarias(convocatoriaClave, body, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FirmaApi - axios parameter creator
 * @export
 */
export const FirmaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Realización de la firma
         * @summary Realización de la firma
         * @param {Firma} firma Firma a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmar: async (firma: Firma, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firma' is not null or undefined
            if (firma === null || firma === undefined) {
                throw new RequiredError('firma','Required parameter firma was null or undefined when calling firmar.');
            }
            const localVarPath = `/firmas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof firma !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(firma !== undefined ? firma : {}) : (firma || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Realización de múltiples firmas
         * @summary Realización de múltiples firmas
         * @param {FirmaMultiple} firmas Firmas a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarMultiple: async (firmas: FirmaMultiple, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmas' is not null or undefined
            if (firmas === null || firmas === undefined) {
                throw new RequiredError('firmas','Required parameter firmas was null or undefined when calling firmarMultiple.');
            }
            const localVarPath = `/firmas/all`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof firmas !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(firmas !== undefined ? firmas : {}) : (firmas || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Valida si el usuario actual puede firmar el documento especificado
         * @summary Valida si se puede firmar el documento
         * @param {string} firmableId Id del firmable que se requiere validar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanSign: async (firmableId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getCanSign.');
            }
            const localVarPath = `/firmas/canSign`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (firmableId !== undefined) {
                localVarQueryParameter['firmableId'] = firmableId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el numero de firmas de la persona logueada
         * @summary Recupera el numero de firmas de la persona logueada
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountFirmasByMe: async (solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/me/count`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (solicitudClave !== undefined) {
                localVarQueryParameter['solicitudClave'] = solicitudClave;
            }

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (tiposDocumento) {
                localVarQueryParameter['tiposDocumento'] = tiposDocumento;
            }

            if (sinFirmar !== undefined) {
                localVarQueryParameter['sinFirmar'] = sinFirmar;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una firma. Puede estar realizada o no
         * @summary Obtiene una firma
         * @param {string} firmableId Id del firmable a consultar
         * @param {string} rfc El número RFC del firmante
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirma: async (firmableId: string, rfc: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getFirma.');
            }
            // verify required parameter 'rfc' is not null or undefined
            if (rfc === null || rfc === undefined) {
                throw new RequiredError('rfc','Required parameter rfc was null or undefined when calling getFirma.');
            }
            const localVarPath = `/firmas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (firmableId !== undefined) {
                localVarQueryParameter['firmableId'] = firmableId;
            }

            if (rfc !== undefined) {
                localVarQueryParameter['rfc'] = rfc;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmasByMe: async (solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/me`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (solicitudClave !== undefined) {
                localVarQueryParameter['solicitudClave'] = solicitudClave;
            }

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (tiposDocumento) {
                localVarQueryParameter['tiposDocumento'] = tiposDocumento;
            }

            if (sinFirmar !== undefined) {
                localVarQueryParameter['sinFirmar'] = sinFirmar;
            }

            if (incluyeData !== undefined) {
                localVarQueryParameter['incluyeData'] = incluyeData;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplacement: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/replacement`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusFirmasByMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/me/status`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
         * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
         * @param {string} firmableId Id del firmable en que se cambiará el estado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciaFirma: async (firmableId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling iniciaFirma.');
            }
            const localVarPath = `/firmas/{firmableId}/iniciaFirma`
                .replace(`{${"firmableId"}}`, encodeURIComponent(String(firmableId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FirmaApi - functional programming interface
 * @export
 */
export const FirmaApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Realización de la firma
         * @summary Realización de la firma
         * @param {Firma} firma Firma a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmar(firma: Firma, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).firmar(firma, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Realización de múltiples firmas
         * @summary Realización de múltiples firmas
         * @param {FirmaMultiple} firmas Firmas a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmarMultiple(firmas: FirmaMultiple, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).firmarMultiple(firmas, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Valida si el usuario actual puede firmar el documento especificado
         * @summary Valida si se puede firmar el documento
         * @param {string} firmableId Id del firmable que se requiere validar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanSign(firmableId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).getCanSign(firmableId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera el numero de firmas de la persona logueada
         * @summary Recupera el numero de firmas de la persona logueada
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).getCountFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una firma. Puede estar realizada o no
         * @summary Obtiene una firma
         * @param {string} firmableId Id del firmable a consultar
         * @param {string} rfc El número RFC del firmante
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirma(firmableId: string, rfc: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firma>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).getFirma(firmableId, rfc, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Firma>>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).getFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, incluyeData, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReplacement(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firma>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).getReplacement(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusFirmasByMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirmaStatusCount>>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).getStatusFirmasByMe(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
         * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
         * @param {string} firmableId Id del firmable en que se cambiará el estado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iniciaFirma(firmableId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firma>> {
            const localVarAxiosArgs = await FirmaApiAxiosParamCreator(configuration).iniciaFirma(firmableId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FirmaApi - factory interface
 * @export
 */
export const FirmaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Realización de la firma
         * @summary Realización de la firma
         * @param {Firma} firma Firma a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmar(firma: Firma, options?: any): AxiosPromise<void> {
            return FirmaApiFp(configuration).firmar(firma, options).then((request) => request(axios, basePath));
        },
        /**
         * Realización de múltiples firmas
         * @summary Realización de múltiples firmas
         * @param {FirmaMultiple} firmas Firmas a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarMultiple(firmas: FirmaMultiple, options?: any): AxiosPromise<void> {
            return FirmaApiFp(configuration).firmarMultiple(firmas, options).then((request) => request(axios, basePath));
        },
        /**
         * Valida si el usuario actual puede firmar el documento especificado
         * @summary Valida si se puede firmar el documento
         * @param {string} firmableId Id del firmable que se requiere validar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanSign(firmableId: string, options?: any): AxiosPromise<boolean> {
            return FirmaApiFp(configuration).getCanSign(firmableId, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el numero de firmas de la persona logueada
         * @summary Recupera el numero de firmas de la persona logueada
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options?: any): AxiosPromise<number> {
            return FirmaApiFp(configuration).getCountFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una firma. Puede estar realizada o no
         * @summary Obtiene una firma
         * @param {string} firmableId Id del firmable a consultar
         * @param {string} rfc El número RFC del firmante
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirma(firmableId: string, rfc: string, options?: any): AxiosPromise<Firma> {
            return FirmaApiFp(configuration).getFirma(firmableId, rfc, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options?: any): AxiosPromise<Array<Firma>> {
            return FirmaApiFp(configuration).getFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, incluyeData, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplacement(options?: any): AxiosPromise<Firma> {
            return FirmaApiFp(configuration).getReplacement(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusFirmasByMe(options?: any): AxiosPromise<Array<FirmaStatusCount>> {
            return FirmaApiFp(configuration).getStatusFirmasByMe(options).then((request) => request(axios, basePath));
        },
        /**
         * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
         * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
         * @param {string} firmableId Id del firmable en que se cambiará el estado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciaFirma(firmableId: string, options?: any): AxiosPromise<Firma> {
            return FirmaApiFp(configuration).iniciaFirma(firmableId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FirmaApi - object-oriented interface
 * @export
 * @class FirmaApi
 * @extends {BaseAPI}
 */
export class FirmaApi extends BaseAPI {
    /**
     * Realización de la firma
     * @summary Realización de la firma
     * @param {Firma} firma Firma a realizar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public firmar(firma: Firma, options?: any) {
        return FirmaApiFp(this.configuration).firmar(firma, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Realización de múltiples firmas
     * @summary Realización de múltiples firmas
     * @param {FirmaMultiple} firmas Firmas a realizar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public firmarMultiple(firmas: FirmaMultiple, options?: any) {
        return FirmaApiFp(this.configuration).firmarMultiple(firmas, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Valida si el usuario actual puede firmar el documento especificado
     * @summary Valida si se puede firmar el documento
     * @param {string} firmableId Id del firmable que se requiere validar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public getCanSign(firmableId: string, options?: any) {
        return FirmaApiFp(this.configuration).getCanSign(firmableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el numero de firmas de la persona logueada
     * @summary Recupera el numero de firmas de la persona logueada
     * @param {string} [solicitudClave] Clave del documento asociado al firmable
     * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
     * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
     * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public getCountFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options?: any) {
        return FirmaApiFp(this.configuration).getCountFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una firma. Puede estar realizada o no
     * @summary Obtiene una firma
     * @param {string} firmableId Id del firmable a consultar
     * @param {string} rfc El número RFC del firmante
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public getFirma(firmableId: string, rfc: string, options?: any) {
        return FirmaApiFp(this.configuration).getFirma(firmableId, rfc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene todas las firmas correspondientes al usuario en sesión
     * @summary Obtiene todas las firmas correspondientes al usuario en sesión
     * @param {string} [solicitudClave] Clave del documento asociado al firmable
     * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
     * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
     * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
     * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public getFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options?: any) {
        return FirmaApiFp(this.configuration).getFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, incluyeData, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene todas las firmas correspondientes al usuario en sesión
     * @summary Obtiene todas las firmas correspondientes al usuario en sesión
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public getReplacement(options?: any) {
        return FirmaApiFp(this.configuration).getReplacement(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
     * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public getStatusFirmasByMe(options?: any) {
        return FirmaApiFp(this.configuration).getStatusFirmasByMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
     * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
     * @param {string} firmableId Id del firmable en que se cambiará el estado
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaApi
     */
    public iniciaFirma(firmableId: string, options?: any) {
        return FirmaApiFp(this.configuration).iniciaFirma(firmableId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FirmableApi - axios parameter creator
 * @export
 */
export const FirmableApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene todos los firmables relacionados a la solicitud especificada.
         * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
         * @param {string} solicitudClave La clave de la solicitud.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFirmablesBySolicitud: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getAllFirmablesBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/firmables`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene las firmas firmable con id especificado
         * @summary Obtiene las firmas del firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaByIdFirmable: async (firmableId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getFirmaByIdFirmable.');
            }
            const localVarPath = `/firmables/{firmableId}/firmas`
                .replace(`{${"firmableId"}}`, encodeURIComponent(String(firmableId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableById: async (firmableId: string, representacionImpresa?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getFirmableById.');
            }
            const localVarPath = `/firmables/{firmableId}`
                .replace(`{${"firmableId"}}`, encodeURIComponent(String(firmableId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (representacionImpresa !== undefined) {
                localVarQueryParameter['representacion_impresa'] = representacionImpresa;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} solicitudClave Id del firmable a consultar
         * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableBySolicitudAndClase: async (solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getFirmableBySolicitudAndClase.');
            }
            // verify required parameter 'clasificacion' is not null or undefined
            if (clasificacion === null || clasificacion === undefined) {
                throw new RequiredError('clasificacion','Required parameter clasificacion was null or undefined when calling getFirmableBySolicitudAndClase.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/firmables/{clasificacion}`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)))
                .replace(`{${"clasificacion"}}`, encodeURIComponent(String(clasificacion)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (representacionImpresa !== undefined) {
                localVarQueryParameter['representacion_impresa'] = representacionImpresa;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FirmableApi - functional programming interface
 * @export
 */
export const FirmableApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Obtiene todos los firmables relacionados a la solicitud especificada.
         * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
         * @param {string} solicitudClave La clave de la solicitud.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFirmablesBySolicitud(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirmableBrief>>> {
            const localVarAxiosArgs = await FirmableApiAxiosParamCreator(configuration).getAllFirmablesBySolicitud(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene las firmas firmable con id especificado
         * @summary Obtiene las firmas del firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmaByIdFirmable(firmableId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Firma>>> {
            const localVarAxiosArgs = await FirmableApiAxiosParamCreator(configuration).getFirmaByIdFirmable(firmableId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmableById(firmableId: string, representacionImpresa?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firmable>> {
            const localVarAxiosArgs = await FirmableApiAxiosParamCreator(configuration).getFirmableById(firmableId, representacionImpresa, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} solicitudClave Id del firmable a consultar
         * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmableBySolicitudAndClase(solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firmable>> {
            const localVarAxiosArgs = await FirmableApiAxiosParamCreator(configuration).getFirmableBySolicitudAndClase(solicitudClave, clasificacion, representacionImpresa, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FirmableApi - factory interface
 * @export
 */
export const FirmableApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtiene todos los firmables relacionados a la solicitud especificada.
         * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
         * @param {string} solicitudClave La clave de la solicitud.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFirmablesBySolicitud(solicitudClave: string, options?: any): AxiosPromise<Array<FirmableBrief>> {
            return FirmableApiFp(configuration).getAllFirmablesBySolicitud(solicitudClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene las firmas firmable con id especificado
         * @summary Obtiene las firmas del firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaByIdFirmable(firmableId: string, options?: any): AxiosPromise<Array<Firma>> {
            return FirmableApiFp(configuration).getFirmaByIdFirmable(firmableId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableById(firmableId: string, representacionImpresa?: boolean, options?: any): AxiosPromise<Firmable> {
            return FirmableApiFp(configuration).getFirmableById(firmableId, representacionImpresa, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} solicitudClave Id del firmable a consultar
         * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableBySolicitudAndClase(solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options?: any): AxiosPromise<Firmable> {
            return FirmableApiFp(configuration).getFirmableBySolicitudAndClase(solicitudClave, clasificacion, representacionImpresa, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FirmableApi - object-oriented interface
 * @export
 * @class FirmableApi
 * @extends {BaseAPI}
 */
export class FirmableApi extends BaseAPI {
    /**
     * Obtiene todos los firmables relacionados a la solicitud especificada.
     * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
     * @param {string} solicitudClave La clave de la solicitud.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmableApi
     */
    public getAllFirmablesBySolicitud(solicitudClave: string, options?: any) {
        return FirmableApiFp(this.configuration).getAllFirmablesBySolicitud(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene las firmas firmable con id especificado
     * @summary Obtiene las firmas del firmable con id especificado
     * @param {string} firmableId Id del firmable a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmableApi
     */
    public getFirmaByIdFirmable(firmableId: string, options?: any) {
        return FirmableApiFp(this.configuration).getFirmaByIdFirmable(firmableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el firmable con id especificado
     * @summary Obtiene el firmable con id especificado
     * @param {string} firmableId Id del firmable a consultar
     * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmableApi
     */
    public getFirmableById(firmableId: string, representacionImpresa?: boolean, options?: any) {
        return FirmableApiFp(this.configuration).getFirmableById(firmableId, representacionImpresa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el firmable con id especificado
     * @summary Obtiene el firmable con id especificado
     * @param {string} solicitudClave Id del firmable a consultar
     * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
     * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmableApi
     */
    public getFirmableBySolicitudAndClase(solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options?: any) {
        return FirmableApiFp(this.configuration).getFirmableBySolicitudAndClase(solicitudClave, clasificacion, representacionImpresa, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FormalizacionApi - axios parameter creator
 * @export
 */
export const FormalizacionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Acepta la aclaración y aplica la modificación.
         * @summary Acepta la aclaración.
         * @param {string} aclaracionId El id de la aclaración.
         * @param {AceptacionAclaracion} [aceptacionAclaracion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aceptarAclaracionBySolicitud: async (aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'aclaracionId' is not null or undefined
            if (aclaracionId === null || aclaracionId === undefined) {
                throw new RequiredError('aclaracionId','Required parameter aclaracionId was null or undefined when calling aceptarAclaracionBySolicitud.');
            }
            const localVarPath = `/aclaraciones/{aclaracionId}/aceptacion`
                .replace(`{${"aclaracionId"}}`, encodeURIComponent(String(aclaracionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof aceptacionAclaracion !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(aceptacionAclaracion !== undefined ? aceptacionAclaracion : {}) : (aceptacionAclaracion || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
         * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agregaSolicitanteComplemento: async (solicitanteComplemento: SolicitanteComplemento, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitanteComplemento' is not null or undefined
            if (solicitanteComplemento === null || solicitanteComplemento === undefined) {
                throw new RequiredError('solicitanteComplemento','Required parameter solicitanteComplemento was null or undefined when calling agregaSolicitanteComplemento.');
            }
            const localVarPath = `/solicitante-complemento`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof solicitanteComplemento !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(solicitanteComplemento !== undefined ? solicitanteComplemento : {}) : (solicitanteComplemento || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        borraSolicitanteComplemento: async (cvu: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            if (cvu === null || cvu === undefined) {
                throw new RequiredError('cvu','Required parameter cvu was null or undefined when calling borraSolicitanteComplemento.');
            }
            const localVarPath = `/solicitante-complemento/{cvu}`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buscarSolicitanteComplementoByCvu: async (cvu: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            if (cvu === null || cvu === undefined) {
                throw new RequiredError('cvu','Required parameter cvu was null or undefined when calling buscarSolicitanteComplementoByCvu.');
            }
            const localVarPath = `/solicitante-complemento/{cvu}`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancela una solicitud dada una clave
         * @summary Cancela una solicitud dada una clave
         * @param {string} solicitudId Id de la solicitud a cancelar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSolicitudById: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling cancelSolicitudById.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/cancel`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirma la información de la cuenta bancaria.
         * @summary Confirma la información de la cuenta bancaria.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmaCuentaBancariaByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling confirmaCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria/confirm`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
         * @summary Crea una aclaración o comenta sobre la actual.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearAclaracionBySolicitud: async (solicitudClave: string, comentario?: Comentario, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling crearAclaracionBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/aclaraciones`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof comentario !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(comentario !== undefined ? comentario : {}) : (comentario || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crea una nueva solicitud a formalizar
         * @summary Crea una nueva solicitud a formalizar
         * @param {Solicitud} solicitud La solicitud a crear.
         * @param {boolean} [async] Indica si la petición es asíncrona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolicitud: async (solicitud: Solicitud, async?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitud' is not null or undefined
            if (solicitud === null || solicitud === undefined) {
                throw new RequiredError('solicitud','Required parameter solicitud was null or undefined when calling createSolicitud.');
            }
            const localVarPath = `/solicitudes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (async !== undefined) {
                localVarQueryParameter['async'] = async;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof solicitud !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(solicitud !== undefined ? solicitud : {}) : (solicitud || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Borra la cuenta bancaria asociada a la solicitud dada.
         * @summary Borra la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCuentaBancariaByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling deleteCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Realización de la firma
         * @summary Realización de la firma
         * @param {Firma} firma Firma a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmar: async (firma: Firma, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firma' is not null or undefined
            if (firma === null || firma === undefined) {
                throw new RequiredError('firma','Required parameter firma was null or undefined when calling firmar.');
            }
            const localVarPath = `/firmas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof firma !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(firma !== undefined ? firma : {}) : (firma || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Realización de múltiples firmas
         * @summary Realización de múltiples firmas
         * @param {FirmaMultiple} firmas Firmas a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarMultiple: async (firmas: FirmaMultiple, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmas' is not null or undefined
            if (firmas === null || firmas === undefined) {
                throw new RequiredError('firmas','Required parameter firmas was null or undefined when calling firmarMultiple.');
            }
            const localVarPath = `/firmas/all`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof firmas !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(firmas !== undefined ? firmas : {}) : (firmas || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una página de convocatorias
         * @summary Obtiene una página de convocatorias
         * @param {string} [areaClave] Clave del area
         * @param {boolean} [activo] Indica si la convocatoria está acitva o no
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConvocatorias: async (areaClave?: string, activo?: boolean, page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/convocatorias`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (areaClave !== undefined) {
                localVarQueryParameter['areaClave'] = areaClave;
            }

            if (activo !== undefined) {
                localVarQueryParameter['activo'] = activo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene todos los firmables relacionados a la solicitud especificada.
         * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
         * @param {string} solicitudClave La clave de la solicitud.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFirmablesBySolicitud: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getAllFirmablesBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/firmables`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una página de modalidades
         * @summary Obtiene una página de modalidades
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModalidades: async (convocatoriaClave?: string, page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/modalidades`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una página de notificaciones
         * @summary Obtiene una página de notificaciones
         * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
         * @param {boolean} [leido] Indica la notificación ha sido leia o no
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificaciones: async (claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/notificaciones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (claveProyecto !== undefined) {
                localVarQueryParameter['claveProyecto'] = claveProyecto;
            }

            if (leido !== undefined) {
                localVarQueryParameter['leido'] = leido;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una página de procesos
         * @summary Obtiene una página de procesos
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProcesos: async (convocatoriaClave?: string, page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/procesos`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
         * @summary Obtiene una página de solicitudes.
         * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [titulo] Título de la solicitud
         * @param {string} [numSolicitud] Numero de solicitud
         * @param {string} [participanteCvu] Numero de cvu del participante
         * @param {string} [institucionClave] Clave de la institución
         * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
         * @param {string} [fechaInicio] Fecha de inicio del proyecto
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudes: async (convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (modalidadClave !== undefined) {
                localVarQueryParameter['modalidadClave'] = modalidadClave;
            }

            if (procesoClave !== undefined) {
                localVarQueryParameter['procesoClave'] = procesoClave;
            }

            if (estadoFormalizacion !== undefined) {
                localVarQueryParameter['estadoFormalizacion'] = estadoFormalizacion;
            }

            if (titulo !== undefined) {
                localVarQueryParameter['titulo'] = titulo;
            }

            if (numSolicitud !== undefined) {
                localVarQueryParameter['numSolicitud'] = numSolicitud;
            }

            if (participanteCvu !== undefined) {
                localVarQueryParameter['participanteCvu'] = participanteCvu;
            }

            if (institucionClave !== undefined) {
                localVarQueryParameter['institucionClave'] = institucionClave;
            }

            if (areaConocimientoId !== undefined) {
                localVarQueryParameter['areaConocimientoId'] = areaConocimientoId;
            }

            if (fechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (fechaInicio as any instanceof Date) ?
                    (fechaInicio as any).toISOString().substr(0,10) :
                    fechaInicio;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApoyoEconomicoByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling getApoyoEconomicoByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Valida si el usuario actual puede firmar el documento especificado
         * @summary Valida si se puede firmar el documento
         * @param {string} firmableId Id del firmable que se requiere validar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanSign: async (firmableId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getCanSign.');
            }
            const localVarPath = `/firmas/canSign`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (firmableId !== undefined) {
                localVarQueryParameter['firmableId'] = firmableId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la convocatoria con la clave especificada
         * @summary Obtiene la convocatoria con la clave especificada
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvocatoria: async (convocatoriaClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling getConvocatoria.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el numero de firmas de la persona logueada
         * @summary Recupera el numero de firmas de la persona logueada
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountFirmasByMe: async (solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/me/count`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (solicitudClave !== undefined) {
                localVarQueryParameter['solicitudClave'] = solicitudClave;
            }

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (tiposDocumento) {
                localVarQueryParameter['tiposDocumento'] = tiposDocumento;
            }

            if (sinFirmar !== undefined) {
                localVarQueryParameter['sinFirmar'] = sinFirmar;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera el numero de solicitudes
         * @param {string} [claveConvocatoria] Clave de la convocatoria
         * @param {string} [claveModalidad] Clave de la modalidad
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountSolicitudes: async (claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/count`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (claveConvocatoria !== undefined) {
                localVarQueryParameter['claveConvocatoria'] = claveConvocatoria;
            }

            if (claveModalidad !== undefined) {
                localVarQueryParameter['claveModalidad'] = claveModalidad;
            }

            if (procesoClave !== undefined) {
                localVarQueryParameter['procesoClave'] = procesoClave;
            }

            if (estadoFormalizacion !== undefined) {
                localVarQueryParameter['estadoFormalizacion'] = estadoFormalizacion;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentaBancariaByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling getCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
         * @summary Obtiene las cuentas bancarias por validar.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentasBancarias: async (convocatoriaClave: string, estado: 'por-validar', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling getCuentasBancarias.');
            }
            // verify required parameter 'estado' is not null or undefined
            if (estado === null || estado === undefined) {
                throw new RequiredError('estado','Required parameter estado was null or undefined when calling getCuentasBancarias.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}/cuentas-bancarias`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (estado !== undefined) {
                localVarQueryParameter['estado'] = estado;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
         * @summary Obtiene los dependientes económicos de la solicitud especificada.
         * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependientesEconomicosByMe: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling getDependientesEconomicosByMe.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/dependientes-economicos`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * El estado actual de la solicitud.
         * @summary El estado actual de la solicitud.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadoFormalizacionBySolicitud: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getEstadoFormalizacionBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/estadoFormalizacion`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
         * @summary Estados de formalizacion que puede consultar el usuario autenticado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadosFormalizacionByMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/estadosFormalizacionByMe`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una firma. Puede estar realizada o no
         * @summary Obtiene una firma
         * @param {string} firmableId Id del firmable a consultar
         * @param {string} rfc El número RFC del firmante
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirma: async (firmableId: string, rfc: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getFirma.');
            }
            // verify required parameter 'rfc' is not null or undefined
            if (rfc === null || rfc === undefined) {
                throw new RequiredError('rfc','Required parameter rfc was null or undefined when calling getFirma.');
            }
            const localVarPath = `/firmas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (firmableId !== undefined) {
                localVarQueryParameter['firmableId'] = firmableId;
            }

            if (rfc !== undefined) {
                localVarQueryParameter['rfc'] = rfc;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene las firmas firmable con id especificado
         * @summary Obtiene las firmas del firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaByIdFirmable: async (firmableId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getFirmaByIdFirmable.');
            }
            const localVarPath = `/firmables/{firmableId}/firmas`
                .replace(`{${"firmableId"}}`, encodeURIComponent(String(firmableId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableById: async (firmableId: string, representacionImpresa?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling getFirmableById.');
            }
            const localVarPath = `/firmables/{firmableId}`
                .replace(`{${"firmableId"}}`, encodeURIComponent(String(firmableId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (representacionImpresa !== undefined) {
                localVarQueryParameter['representacion_impresa'] = representacionImpresa;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} solicitudClave Id del firmable a consultar
         * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableBySolicitudAndClase: async (solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getFirmableBySolicitudAndClase.');
            }
            // verify required parameter 'clasificacion' is not null or undefined
            if (clasificacion === null || clasificacion === undefined) {
                throw new RequiredError('clasificacion','Required parameter clasificacion was null or undefined when calling getFirmableBySolicitudAndClase.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/firmables/{clasificacion}`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)))
                .replace(`{${"clasificacion"}}`, encodeURIComponent(String(clasificacion)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (representacionImpresa !== undefined) {
                localVarQueryParameter['representacion_impresa'] = representacionImpresa;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmasByMe: async (solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/me`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (solicitudClave !== undefined) {
                localVarQueryParameter['solicitudClave'] = solicitudClave;
            }

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (tiposDocumento) {
                localVarQueryParameter['tiposDocumento'] = tiposDocumento;
            }

            if (sinFirmar !== undefined) {
                localVarQueryParameter['sinFirmar'] = sinFirmar;
            }

            if (incluyeData !== undefined) {
                localVarQueryParameter['incluyeData'] = incluyeData;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la modalidad con la clave especificada
         * @summary Obtiene la modalidad con la clave especificada
         * @param {string} modalidadClave Clave de la modalidad a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModalidad: async (modalidadClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'modalidadClave' is not null or undefined
            if (modalidadClave === null || modalidadClave === undefined) {
                throw new RequiredError('modalidadClave','Required parameter modalidadClave was null or undefined when calling getModalidad.');
            }
            const localVarPath = `/modalidades/{modalidadClave}`
                .replace(`{${"modalidadClave"}}`, encodeURIComponent(String(modalidadClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una lista de notificaciones
         * @summary Obtiene una lista de notificaciones
         * @param {string} notificacionId Notificación a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificacion: async (notificacionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificacionId' is not null or undefined
            if (notificacionId === null || notificacionId === undefined) {
                throw new RequiredError('notificacionId','Required parameter notificacionId was null or undefined when calling getNotificacion.');
            }
            const localVarPath = `/notificaciones/{notificacionId}`
                .replace(`{${"notificacionId"}}`, encodeURIComponent(String(notificacionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la cantidad de documentos para la convocatoria
         * @summary Obtiene la cantidad de documentos para la convocatoria
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumDocumentosConvocatoria: async (convocatoriaClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling getNumDocumentosConvocatoria.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}/num-documentos`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera un arreglo con las participaciones que tiene el usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipacionesSolicitudes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/participaciones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la proceso con la clave especificada
         * @summary Obtiene la proceso con la clave especificada
         * @param {string} procesoClave Clave de la proceso a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProceso: async (procesoClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'procesoClave' is not null or undefined
            if (procesoClave === null || procesoClave === undefined) {
                throw new RequiredError('procesoClave','Required parameter procesoClave was null or undefined when calling getProceso.');
            }
            const localVarPath = `/procesos/{procesoClave}`
                .replace(`{${"procesoClave"}}`, encodeURIComponent(String(procesoClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplacement: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/replacement`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la solicitud con la clave especificada
         * @summary Obtiene la solicitud con la clave especificada
         * @param {string} solicitudClave Clave de la solicitud a consultar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitud: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getSolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusFirmasByMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas/me/status`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la última aclaración de la solicitud especificada.
         * @summary Obtiene la última aclaración de la solicitud especificada.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {0} page Número de la pagina
         * @param {1} size Elementos por página
         * @param {'desc'} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUltimaAclaracionBySolicitud: async (solicitudClave: string, page: 0, size: 1, sort: 'desc', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            // verify required parameter 'sort' is not null or undefined
            if (sort === null || sort === undefined) {
                throw new RequiredError('sort','Required parameter sort was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/aclaraciones`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
         * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
         * @param {string} firmableId Id del firmable en que se cambiará el estado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciaFirma: async (firmableId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmableId' is not null or undefined
            if (firmableId === null || firmableId === undefined) {
                throw new RequiredError('firmableId','Required parameter firmableId was null or undefined when calling iniciaFirma.');
            }
            const localVarPath = `/firmas/{firmableId}/iniciaFirma`
                .replace(`{${"firmableId"}}`, encodeURIComponent(String(firmableId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadValidacionCuentasBancarias: async (convocatoriaClave: string, body: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'convocatoriaClave' is not null or undefined
            if (convocatoriaClave === null || convocatoriaClave === undefined) {
                throw new RequiredError('convocatoriaClave','Required parameter convocatoriaClave was null or undefined when calling loadValidacionCuentasBancarias.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadValidacionCuentasBancarias.');
            }
            const localVarPath = `/convocatorias/{convocatoriaClave}/cuentas-bancarias`
                .replace(`{${"convocatoriaClave"}}`, encodeURIComponent(String(convocatoriaClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/octet-stream';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rechaza una aclaración abierta
         * @summary Rechaza una aclaración abierta
         * @param {string} aclaracionId El id de la aclaración.
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazaAclaracionBySolicitud: async (aclaracionId: string, comentario?: Comentario, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'aclaracionId' is not null or undefined
            if (aclaracionId === null || aclaracionId === undefined) {
                throw new RequiredError('aclaracionId','Required parameter aclaracionId was null or undefined when calling rechazaAclaracionBySolicitud.');
            }
            const localVarPath = `/aclaraciones/{aclaracionId}/rechazo`
                .replace(`{${"aclaracionId"}}`, encodeURIComponent(String(aclaracionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof comentario !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(comentario !== undefined ? comentario : {}) : (comentario || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
         * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
         * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
         * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneraFirmables: async (solicitudId: string, deleteFirma: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling regeneraFirmables.');
            }
            // verify required parameter 'deleteFirma' is not null or undefined
            if (deleteFirma === null || deleteFirma === undefined) {
                throw new RequiredError('deleteFirma','Required parameter deleteFirma was null or undefined when calling regeneraFirmables.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/regenera-firmables`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (deleteFirma !== undefined) {
                localVarQueryParameter['deleteFirma'] = deleteFirma;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
         * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setApoyoEconomicoByParticipacion: async (solicitudId: string, apoyoEconomico: ApoyoEconomico, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling setApoyoEconomicoByParticipacion.');
            }
            // verify required parameter 'apoyoEconomico' is not null or undefined
            if (apoyoEconomico === null || apoyoEconomico === undefined) {
                throw new RequiredError('apoyoEconomico','Required parameter apoyoEconomico was null or undefined when calling setApoyoEconomicoByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof apoyoEconomico !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(apoyoEconomico !== undefined ? apoyoEconomico : {}) : (apoyoEconomico || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCuentaBancariaByParticipacion: async (solicitudId: string, cuentaBancaria: CuentaBancaria, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling setCuentaBancariaByParticipacion.');
            }
            // verify required parameter 'cuentaBancaria' is not null or undefined
            if (cuentaBancaria === null || cuentaBancaria === undefined) {
                throw new RequiredError('cuentaBancaria','Required parameter cuentaBancaria was null or undefined when calling setCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cuentaBancaria !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cuentaBancaria !== undefined ? cuentaBancaria : {}) : (cuentaBancaria || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza los dependientes económicos de la solicitud dada.
         * @summary Actualiza los dependientes económicos de la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
         * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependientesEconomicosByMe: async (solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling updateDependientesEconomicosByMe.');
            }
            // verify required parameter 'dependienteEconomico' is not null or undefined
            if (dependienteEconomico === null || dependienteEconomico === undefined) {
                throw new RequiredError('dependienteEconomico','Required parameter dependienteEconomico was null or undefined when calling updateDependientesEconomicosByMe.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/dependientes-economicos`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof dependienteEconomico !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(dependienteEconomico !== undefined ? dependienteEconomico : {}) : (dependienteEconomico || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza estatus de la notificación
         * @summary Actualiza estatus de la notificación
         * @param {string} notificacionId Identificador de la notificación
         * @param {Notificacion} notificacion Notificación con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEstatusNotificacion: async (notificacionId: string, notificacion: Notificacion, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificacionId' is not null or undefined
            if (notificacionId === null || notificacionId === undefined) {
                throw new RequiredError('notificacionId','Required parameter notificacionId was null or undefined when calling updateEstatusNotificacion.');
            }
            // verify required parameter 'notificacion' is not null or undefined
            if (notificacion === null || notificacion === undefined) {
                throw new RequiredError('notificacion','Required parameter notificacion was null or undefined when calling updateEstatusNotificacion.');
            }
            const localVarPath = `/notificaciones/{notificacionId}`
                .replace(`{${"notificacionId"}}`, encodeURIComponent(String(notificacionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof notificacion !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(notificacion !== undefined ? notificacion : {}) : (notificacion || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza la solicitud
         * @summary Actualiza la solicitud
         * @param {Solicitud} solicitud Solicitud con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSolicitud: async (solicitud: Solicitud, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitud' is not null or undefined
            if (solicitud === null || solicitud === undefined) {
                throw new RequiredError('solicitud','Required parameter solicitud was null or undefined when calling updateSolicitud.');
            }
            const localVarPath = `/solicitudes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof solicitud !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(solicitud !== undefined ? solicitud : {}) : (solicitud || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
         * @summary Indica que los documentos están validados por parte del solicitante.
         * @param {string} solicitudClave Clave de la solicitud a cambiar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentos: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling validaDocumentos.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/valida-documentos`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormalizacionApi - functional programming interface
 * @export
 */
export const FormalizacionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Acepta la aclaración y aplica la modificación.
         * @summary Acepta la aclaración.
         * @param {string} aclaracionId El id de la aclaración.
         * @param {AceptacionAclaracion} [aceptacionAclaracion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aceptarAclaracionBySolicitud(aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).aceptarAclaracionBySolicitud(aclaracionId, aceptacionAclaracion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
         * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agregaSolicitanteComplemento(solicitanteComplemento: SolicitanteComplemento, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).agregaSolicitanteComplemento(solicitanteComplemento, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async borraSolicitanteComplemento(cvu: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).borraSolicitanteComplemento(cvu, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buscarSolicitanteComplementoByCvu(cvu: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolicitanteComplemento>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).buscarSolicitanteComplementoByCvu(cvu, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancela una solicitud dada una clave
         * @summary Cancela una solicitud dada una clave
         * @param {string} solicitudId Id de la solicitud a cancelar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSolicitudById(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).cancelSolicitudById(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirma la información de la cuenta bancaria.
         * @summary Confirma la información de la cuenta bancaria.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmaCuentaBancariaByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).confirmaCuentaBancariaByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
         * @summary Crea una aclaración o comenta sobre la actual.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crearAclaracionBySolicitud(solicitudClave: string, comentario?: Comentario, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).crearAclaracionBySolicitud(solicitudClave, comentario, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Crea una nueva solicitud a formalizar
         * @summary Crea una nueva solicitud a formalizar
         * @param {Solicitud} solicitud La solicitud a crear.
         * @param {boolean} [async] Indica si la petición es asíncrona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSolicitud(solicitud: Solicitud, async?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).createSolicitud(solicitud, async, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Borra la cuenta bancaria asociada a la solicitud dada.
         * @summary Borra la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCuentaBancariaByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).deleteCuentaBancariaByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Realización de la firma
         * @summary Realización de la firma
         * @param {Firma} firma Firma a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmar(firma: Firma, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).firmar(firma, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Realización de múltiples firmas
         * @summary Realización de múltiples firmas
         * @param {FirmaMultiple} firmas Firmas a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmarMultiple(firmas: FirmaMultiple, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).firmarMultiple(firmas, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una página de convocatorias
         * @summary Obtiene una página de convocatorias
         * @param {string} [areaClave] Clave del area
         * @param {boolean} [activo] Indica si la convocatoria está acitva o no
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConvocatorias(areaClave?: string, activo?: boolean, page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConvocatoriaBrief>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getAllConvocatorias(areaClave, activo, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene todos los firmables relacionados a la solicitud especificada.
         * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
         * @param {string} solicitudClave La clave de la solicitud.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFirmablesBySolicitud(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirmableBrief>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getAllFirmablesBySolicitud(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una página de modalidades
         * @summary Obtiene una página de modalidades
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllModalidades(convocatoriaClave?: string, page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Modalidad>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getAllModalidades(convocatoriaClave, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una página de notificaciones
         * @summary Obtiene una página de notificaciones
         * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
         * @param {boolean} [leido] Indica la notificación ha sido leia o no
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotificaciones(claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notificacion>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getAllNotificaciones(claveProyecto, leido, sort, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una página de procesos
         * @summary Obtiene una página de procesos
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProcesos(convocatoriaClave?: string, page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Proceso>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getAllProcesos(convocatoriaClave, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
         * @summary Obtiene una página de solicitudes.
         * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [titulo] Título de la solicitud
         * @param {string} [numSolicitud] Numero de solicitud
         * @param {string} [participanteCvu] Numero de cvu del participante
         * @param {string} [institucionClave] Clave de la institución
         * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
         * @param {string} [fechaInicio] Fecha de inicio del proyecto
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSolicitudes(convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SolicitudBrief>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getAllSolicitudes(convocatoriaClave, modalidadClave, procesoClave, estadoFormalizacion, titulo, numSolicitud, participanteCvu, institucionClave, areaConocimientoId, fechaInicio, page, size, sortBy, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApoyoEconomicoByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApoyoEconomico>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getApoyoEconomicoByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Valida si el usuario actual puede firmar el documento especificado
         * @summary Valida si se puede firmar el documento
         * @param {string} firmableId Id del firmable que se requiere validar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanSign(firmableId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getCanSign(firmableId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la convocatoria con la clave especificada
         * @summary Obtiene la convocatoria con la clave especificada
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConvocatoria(convocatoriaClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Convocatoria>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getConvocatoria(convocatoriaClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera el numero de firmas de la persona logueada
         * @summary Recupera el numero de firmas de la persona logueada
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getCountFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera el numero de solicitudes
         * @param {string} [claveConvocatoria] Clave de la convocatoria
         * @param {string} [claveModalidad] Clave de la modalidad
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountSolicitudes(claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getCountSolicitudes(claveConvocatoria, claveModalidad, procesoClave, estadoFormalizacion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCuentaBancariaByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CuentaBancaria>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getCuentaBancariaByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
         * @summary Obtiene las cuentas bancarias por validar.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCuentasBancarias(convocatoriaClave: string, estado: 'por-validar', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getCuentasBancarias(convocatoriaClave, estado, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
         * @summary Obtiene los dependientes económicos de la solicitud especificada.
         * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependientesEconomicosByMe(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DependienteEconomico>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getDependientesEconomicosByMe(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * El estado actual de la solicitud.
         * @summary El estado actual de la solicitud.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadoFormalizacionBySolicitud(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstadoFormalizacion>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getEstadoFormalizacionBySolicitud(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
         * @summary Estados de formalizacion que puede consultar el usuario autenticado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadosFormalizacionByMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EstadoFormalizacion>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getEstadosFormalizacionByMe(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una firma. Puede estar realizada o no
         * @summary Obtiene una firma
         * @param {string} firmableId Id del firmable a consultar
         * @param {string} rfc El número RFC del firmante
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirma(firmableId: string, rfc: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firma>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getFirma(firmableId, rfc, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene las firmas firmable con id especificado
         * @summary Obtiene las firmas del firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmaByIdFirmable(firmableId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Firma>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getFirmaByIdFirmable(firmableId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmableById(firmableId: string, representacionImpresa?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firmable>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getFirmableById(firmableId, representacionImpresa, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} solicitudClave Id del firmable a consultar
         * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmableBySolicitudAndClase(solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firmable>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getFirmableBySolicitudAndClase(solicitudClave, clasificacion, representacionImpresa, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Firma>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, incluyeData, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la modalidad con la clave especificada
         * @summary Obtiene la modalidad con la clave especificada
         * @param {string} modalidadClave Clave de la modalidad a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModalidad(modalidadClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modalidad>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getModalidad(modalidadClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una lista de notificaciones
         * @summary Obtiene una lista de notificaciones
         * @param {string} notificacionId Notificación a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificacion(notificacionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notificacion>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getNotificacion(notificacionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la cantidad de documentos para la convocatoria
         * @summary Obtiene la cantidad de documentos para la convocatoria
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumDocumentosConvocatoria(convocatoriaClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getNumDocumentosConvocatoria(convocatoriaClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera un arreglo con las participaciones que tiene el usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParticipacionesSolicitudes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParticipacionCount>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getParticipacionesSolicitudes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la proceso con la clave especificada
         * @summary Obtiene la proceso con la clave especificada
         * @param {string} procesoClave Clave de la proceso a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProceso(procesoClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Proceso>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getProceso(procesoClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReplacement(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firma>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getReplacement(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la solicitud con la clave especificada
         * @summary Obtiene la solicitud con la clave especificada
         * @param {string} solicitudClave Clave de la solicitud a consultar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolicitud(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Solicitud>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getSolicitud(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusFirmasByMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirmaStatusCount>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getStatusFirmasByMe(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la última aclaración de la solicitud especificada.
         * @summary Obtiene la última aclaración de la solicitud especificada.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {0} page Número de la pagina
         * @param {1} size Elementos por página
         * @param {'desc'} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUltimaAclaracionBySolicitud(solicitudClave: string, page: 0, size: 1, sort: 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Aclaracion>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).getUltimaAclaracionBySolicitud(solicitudClave, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
         * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
         * @param {string} firmableId Id del firmable en que se cambiará el estado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iniciaFirma(firmableId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Firma>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).iniciaFirma(firmableId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadValidacionCuentasBancarias(convocatoriaClave: string, body: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).loadValidacionCuentasBancarias(convocatoriaClave, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Rechaza una aclaración abierta
         * @summary Rechaza una aclaración abierta
         * @param {string} aclaracionId El id de la aclaración.
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechazaAclaracionBySolicitud(aclaracionId: string, comentario?: Comentario, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).rechazaAclaracionBySolicitud(aclaracionId, comentario, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
         * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
         * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
         * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regeneraFirmables(solicitudId: string, deleteFirma: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Firmable>>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).regeneraFirmables(solicitudId, deleteFirma, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
         * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setApoyoEconomicoByParticipacion(solicitudId: string, apoyoEconomico: ApoyoEconomico, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).setApoyoEconomicoByParticipacion(solicitudId, apoyoEconomico, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCuentaBancariaByParticipacion(solicitudId: string, cuentaBancaria: CuentaBancaria, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).setCuentaBancariaByParticipacion(solicitudId, cuentaBancaria, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Actualiza los dependientes económicos de la solicitud dada.
         * @summary Actualiza los dependientes económicos de la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
         * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDependientesEconomicosByMe(solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).updateDependientesEconomicosByMe(solicitudId, dependienteEconomico, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Actualiza estatus de la notificación
         * @summary Actualiza estatus de la notificación
         * @param {string} notificacionId Identificador de la notificación
         * @param {Notificacion} notificacion Notificación con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEstatusNotificacion(notificacionId: string, notificacion: Notificacion, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).updateEstatusNotificacion(notificacionId, notificacion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Actualiza la solicitud
         * @summary Actualiza la solicitud
         * @param {Solicitud} solicitud Solicitud con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSolicitud(solicitud: Solicitud, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).updateSolicitud(solicitud, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
         * @summary Indica que los documentos están validados por parte del solicitante.
         * @param {string} solicitudClave Clave de la solicitud a cambiar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentos(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FormalizacionApiAxiosParamCreator(configuration).validaDocumentos(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FormalizacionApi - factory interface
 * @export
 */
export const FormalizacionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Acepta la aclaración y aplica la modificación.
         * @summary Acepta la aclaración.
         * @param {string} aclaracionId El id de la aclaración.
         * @param {AceptacionAclaracion} [aceptacionAclaracion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aceptarAclaracionBySolicitud(aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).aceptarAclaracionBySolicitud(aclaracionId, aceptacionAclaracion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
         * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agregaSolicitanteComplemento(solicitanteComplemento: SolicitanteComplemento, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).agregaSolicitanteComplemento(solicitanteComplemento, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        borraSolicitanteComplemento(cvu: string, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).borraSolicitanteComplemento(cvu, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buscarSolicitanteComplementoByCvu(cvu: string, options?: any): AxiosPromise<SolicitanteComplemento> {
            return FormalizacionApiFp(configuration).buscarSolicitanteComplementoByCvu(cvu, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancela una solicitud dada una clave
         * @summary Cancela una solicitud dada una clave
         * @param {string} solicitudId Id de la solicitud a cancelar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSolicitudById(solicitudId: string, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).cancelSolicitudById(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirma la información de la cuenta bancaria.
         * @summary Confirma la información de la cuenta bancaria.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmaCuentaBancariaByParticipacion(solicitudId: string, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).confirmaCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
         * @summary Crea una aclaración o comenta sobre la actual.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearAclaracionBySolicitud(solicitudClave: string, comentario?: Comentario, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).crearAclaracionBySolicitud(solicitudClave, comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * Crea una nueva solicitud a formalizar
         * @summary Crea una nueva solicitud a formalizar
         * @param {Solicitud} solicitud La solicitud a crear.
         * @param {boolean} [async] Indica si la petición es asíncrona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolicitud(solicitud: Solicitud, async?: boolean, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).createSolicitud(solicitud, async, options).then((request) => request(axios, basePath));
        },
        /**
         * Borra la cuenta bancaria asociada a la solicitud dada.
         * @summary Borra la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCuentaBancariaByParticipacion(solicitudId: string, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).deleteCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Realización de la firma
         * @summary Realización de la firma
         * @param {Firma} firma Firma a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmar(firma: Firma, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).firmar(firma, options).then((request) => request(axios, basePath));
        },
        /**
         * Realización de múltiples firmas
         * @summary Realización de múltiples firmas
         * @param {FirmaMultiple} firmas Firmas a realizar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarMultiple(firmas: FirmaMultiple, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).firmarMultiple(firmas, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una página de convocatorias
         * @summary Obtiene una página de convocatorias
         * @param {string} [areaClave] Clave del area
         * @param {boolean} [activo] Indica si la convocatoria está acitva o no
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConvocatorias(areaClave?: string, activo?: boolean, page?: number, size?: number, options?: any): AxiosPromise<Array<ConvocatoriaBrief>> {
            return FormalizacionApiFp(configuration).getAllConvocatorias(areaClave, activo, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene todos los firmables relacionados a la solicitud especificada.
         * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
         * @param {string} solicitudClave La clave de la solicitud.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFirmablesBySolicitud(solicitudClave: string, options?: any): AxiosPromise<Array<FirmableBrief>> {
            return FormalizacionApiFp(configuration).getAllFirmablesBySolicitud(solicitudClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una página de modalidades
         * @summary Obtiene una página de modalidades
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModalidades(convocatoriaClave?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Modalidad>> {
            return FormalizacionApiFp(configuration).getAllModalidades(convocatoriaClave, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una página de notificaciones
         * @summary Obtiene una página de notificaciones
         * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
         * @param {boolean} [leido] Indica la notificación ha sido leia o no
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificaciones(claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options?: any): AxiosPromise<Array<Notificacion>> {
            return FormalizacionApiFp(configuration).getAllNotificaciones(claveProyecto, leido, sort, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una página de procesos
         * @summary Obtiene una página de procesos
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProcesos(convocatoriaClave?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Proceso>> {
            return FormalizacionApiFp(configuration).getAllProcesos(convocatoriaClave, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
         * @summary Obtiene una página de solicitudes.
         * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [titulo] Título de la solicitud
         * @param {string} [numSolicitud] Numero de solicitud
         * @param {string} [participanteCvu] Numero de cvu del participante
         * @param {string} [institucionClave] Clave de la institución
         * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
         * @param {string} [fechaInicio] Fecha de inicio del proyecto
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudes(convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options?: any): AxiosPromise<Array<SolicitudBrief>> {
            return FormalizacionApiFp(configuration).getAllSolicitudes(convocatoriaClave, modalidadClave, procesoClave, estadoFormalizacion, titulo, numSolicitud, participanteCvu, institucionClave, areaConocimientoId, fechaInicio, page, size, sortBy, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApoyoEconomicoByParticipacion(solicitudId: string, options?: any): AxiosPromise<ApoyoEconomico> {
            return FormalizacionApiFp(configuration).getApoyoEconomicoByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Valida si el usuario actual puede firmar el documento especificado
         * @summary Valida si se puede firmar el documento
         * @param {string} firmableId Id del firmable que se requiere validar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanSign(firmableId: string, options?: any): AxiosPromise<boolean> {
            return FormalizacionApiFp(configuration).getCanSign(firmableId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la convocatoria con la clave especificada
         * @summary Obtiene la convocatoria con la clave especificada
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvocatoria(convocatoriaClave: string, options?: any): AxiosPromise<Convocatoria> {
            return FormalizacionApiFp(configuration).getConvocatoria(convocatoriaClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el numero de firmas de la persona logueada
         * @summary Recupera el numero de firmas de la persona logueada
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options?: any): AxiosPromise<number> {
            return FormalizacionApiFp(configuration).getCountFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera el numero de solicitudes
         * @param {string} [claveConvocatoria] Clave de la convocatoria
         * @param {string} [claveModalidad] Clave de la modalidad
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountSolicitudes(claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options?: any): AxiosPromise<number> {
            return FormalizacionApiFp(configuration).getCountSolicitudes(claveConvocatoria, claveModalidad, procesoClave, estadoFormalizacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentaBancariaByParticipacion(solicitudId: string, options?: any): AxiosPromise<CuentaBancaria> {
            return FormalizacionApiFp(configuration).getCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
         * @summary Obtiene las cuentas bancarias por validar.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentasBancarias(convocatoriaClave: string, estado: 'por-validar', options?: any): AxiosPromise<string> {
            return FormalizacionApiFp(configuration).getCuentasBancarias(convocatoriaClave, estado, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
         * @summary Obtiene los dependientes económicos de la solicitud especificada.
         * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependientesEconomicosByMe(solicitudId: string, options?: any): AxiosPromise<Array<DependienteEconomico>> {
            return FormalizacionApiFp(configuration).getDependientesEconomicosByMe(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * El estado actual de la solicitud.
         * @summary El estado actual de la solicitud.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadoFormalizacionBySolicitud(solicitudClave: string, options?: any): AxiosPromise<EstadoFormalizacion> {
            return FormalizacionApiFp(configuration).getEstadoFormalizacionBySolicitud(solicitudClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
         * @summary Estados de formalizacion que puede consultar el usuario autenticado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadosFormalizacionByMe(options?: any): AxiosPromise<Array<EstadoFormalizacion>> {
            return FormalizacionApiFp(configuration).getEstadosFormalizacionByMe(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una firma. Puede estar realizada o no
         * @summary Obtiene una firma
         * @param {string} firmableId Id del firmable a consultar
         * @param {string} rfc El número RFC del firmante
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirma(firmableId: string, rfc: string, options?: any): AxiosPromise<Firma> {
            return FormalizacionApiFp(configuration).getFirma(firmableId, rfc, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene las firmas firmable con id especificado
         * @summary Obtiene las firmas del firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmaByIdFirmable(firmableId: string, options?: any): AxiosPromise<Array<Firma>> {
            return FormalizacionApiFp(configuration).getFirmaByIdFirmable(firmableId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} firmableId Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableById(firmableId: string, representacionImpresa?: boolean, options?: any): AxiosPromise<Firmable> {
            return FormalizacionApiFp(configuration).getFirmableById(firmableId, representacionImpresa, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el firmable con id especificado
         * @summary Obtiene el firmable con id especificado
         * @param {string} solicitudClave Id del firmable a consultar
         * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
         * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmableBySolicitudAndClase(solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options?: any): AxiosPromise<Firmable> {
            return FormalizacionApiFp(configuration).getFirmableBySolicitudAndClase(solicitudClave, clasificacion, representacionImpresa, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {string} [solicitudClave] Clave del documento asociado al firmable
         * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
         * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
         * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
         * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options?: any): AxiosPromise<Array<Firma>> {
            return FormalizacionApiFp(configuration).getFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, incluyeData, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la modalidad con la clave especificada
         * @summary Obtiene la modalidad con la clave especificada
         * @param {string} modalidadClave Clave de la modalidad a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModalidad(modalidadClave: string, options?: any): AxiosPromise<Modalidad> {
            return FormalizacionApiFp(configuration).getModalidad(modalidadClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una lista de notificaciones
         * @summary Obtiene una lista de notificaciones
         * @param {string} notificacionId Notificación a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificacion(notificacionId: string, options?: any): AxiosPromise<Notificacion> {
            return FormalizacionApiFp(configuration).getNotificacion(notificacionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la cantidad de documentos para la convocatoria
         * @summary Obtiene la cantidad de documentos para la convocatoria
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumDocumentosConvocatoria(convocatoriaClave: string, options?: any): AxiosPromise<number> {
            return FormalizacionApiFp(configuration).getNumDocumentosConvocatoria(convocatoriaClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera un arreglo con las participaciones que tiene el usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipacionesSolicitudes(options?: any): AxiosPromise<Array<ParticipacionCount>> {
            return FormalizacionApiFp(configuration).getParticipacionesSolicitudes(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la proceso con la clave especificada
         * @summary Obtiene la proceso con la clave especificada
         * @param {string} procesoClave Clave de la proceso a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProceso(procesoClave: string, options?: any): AxiosPromise<Proceso> {
            return FormalizacionApiFp(configuration).getProceso(procesoClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene todas las firmas correspondientes al usuario en sesión
         * @summary Obtiene todas las firmas correspondientes al usuario en sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplacement(options?: any): AxiosPromise<Firma> {
            return FormalizacionApiFp(configuration).getReplacement(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la solicitud con la clave especificada
         * @summary Obtiene la solicitud con la clave especificada
         * @param {string} solicitudClave Clave de la solicitud a consultar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitud(solicitudClave: string, options?: any): AxiosPromise<Solicitud> {
            return FormalizacionApiFp(configuration).getSolicitud(solicitudClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusFirmasByMe(options?: any): AxiosPromise<Array<FirmaStatusCount>> {
            return FormalizacionApiFp(configuration).getStatusFirmasByMe(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la última aclaración de la solicitud especificada.
         * @summary Obtiene la última aclaración de la solicitud especificada.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {0} page Número de la pagina
         * @param {1} size Elementos por página
         * @param {'desc'} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUltimaAclaracionBySolicitud(solicitudClave: string, page: 0, size: 1, sort: 'desc', options?: any): AxiosPromise<Aclaracion> {
            return FormalizacionApiFp(configuration).getUltimaAclaracionBySolicitud(solicitudClave, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
         * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
         * @param {string} firmableId Id del firmable en que se cambiará el estado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciaFirma(firmableId: string, options?: any): AxiosPromise<Firma> {
            return FormalizacionApiFp(configuration).iniciaFirma(firmableId, options).then((request) => request(axios, basePath));
        },
        /**
         * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
         * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
         * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadValidacionCuentasBancarias(convocatoriaClave: string, body: any, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).loadValidacionCuentasBancarias(convocatoriaClave, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Rechaza una aclaración abierta
         * @summary Rechaza una aclaración abierta
         * @param {string} aclaracionId El id de la aclaración.
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazaAclaracionBySolicitud(aclaracionId: string, comentario?: Comentario, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).rechazaAclaracionBySolicitud(aclaracionId, comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
         * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
         * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
         * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneraFirmables(solicitudId: string, deleteFirma: boolean, options?: any): AxiosPromise<Array<Firmable>> {
            return FormalizacionApiFp(configuration).regeneraFirmables(solicitudId, deleteFirma, options).then((request) => request(axios, basePath));
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
         * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setApoyoEconomicoByParticipacion(solicitudId: string, apoyoEconomico: ApoyoEconomico, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).setApoyoEconomicoByParticipacion(solicitudId, apoyoEconomico, options).then((request) => request(axios, basePath));
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCuentaBancariaByParticipacion(solicitudId: string, cuentaBancaria: CuentaBancaria, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).setCuentaBancariaByParticipacion(solicitudId, cuentaBancaria, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza los dependientes económicos de la solicitud dada.
         * @summary Actualiza los dependientes económicos de la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
         * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependientesEconomicosByMe(solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).updateDependientesEconomicosByMe(solicitudId, dependienteEconomico, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza estatus de la notificación
         * @summary Actualiza estatus de la notificación
         * @param {string} notificacionId Identificador de la notificación
         * @param {Notificacion} notificacion Notificación con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEstatusNotificacion(notificacionId: string, notificacion: Notificacion, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).updateEstatusNotificacion(notificacionId, notificacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza la solicitud
         * @summary Actualiza la solicitud
         * @param {Solicitud} solicitud Solicitud con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSolicitud(solicitud: Solicitud, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).updateSolicitud(solicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
         * @summary Indica que los documentos están validados por parte del solicitante.
         * @param {string} solicitudClave Clave de la solicitud a cambiar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentos(solicitudClave: string, options?: any): AxiosPromise<void> {
            return FormalizacionApiFp(configuration).validaDocumentos(solicitudClave, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormalizacionApi - object-oriented interface
 * @export
 * @class FormalizacionApi
 * @extends {BaseAPI}
 */
export class FormalizacionApi extends BaseAPI {
    /**
     * Acepta la aclaración y aplica la modificación.
     * @summary Acepta la aclaración.
     * @param {string} aclaracionId El id de la aclaración.
     * @param {AceptacionAclaracion} [aceptacionAclaracion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public aceptarAclaracionBySolicitud(aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options?: any) {
        return FormalizacionApiFp(this.configuration).aceptarAclaracionBySolicitud(aclaracionId, aceptacionAclaracion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
     * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public agregaSolicitanteComplemento(solicitanteComplemento: SolicitanteComplemento, options?: any) {
        return FormalizacionApiFp(this.configuration).agregaSolicitanteComplemento(solicitanteComplemento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Busca información extra de un solicitante por su CVU
     * @param {string} cvu 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public borraSolicitanteComplemento(cvu: string, options?: any) {
        return FormalizacionApiFp(this.configuration).borraSolicitanteComplemento(cvu, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Busca información extra de un solicitante por su CVU
     * @param {string} cvu 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public buscarSolicitanteComplementoByCvu(cvu: string, options?: any) {
        return FormalizacionApiFp(this.configuration).buscarSolicitanteComplementoByCvu(cvu, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancela una solicitud dada una clave
     * @summary Cancela una solicitud dada una clave
     * @param {string} solicitudId Id de la solicitud a cancelar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public cancelSolicitudById(solicitudId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).cancelSolicitudById(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirma la información de la cuenta bancaria.
     * @summary Confirma la información de la cuenta bancaria.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public confirmaCuentaBancariaByParticipacion(solicitudId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).confirmaCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
     * @summary Crea una aclaración o comenta sobre la actual.
     * @param {string} solicitudClave Clave de la solicitud a consultar
     * @param {Comentario} [comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public crearAclaracionBySolicitud(solicitudClave: string, comentario?: Comentario, options?: any) {
        return FormalizacionApiFp(this.configuration).crearAclaracionBySolicitud(solicitudClave, comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crea una nueva solicitud a formalizar
     * @summary Crea una nueva solicitud a formalizar
     * @param {Solicitud} solicitud La solicitud a crear.
     * @param {boolean} [async] Indica si la petición es asíncrona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public createSolicitud(solicitud: Solicitud, async?: boolean, options?: any) {
        return FormalizacionApiFp(this.configuration).createSolicitud(solicitud, async, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Borra la cuenta bancaria asociada a la solicitud dada.
     * @summary Borra la cuenta bancaria asociada a la participación.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public deleteCuentaBancariaByParticipacion(solicitudId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).deleteCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Realización de la firma
     * @summary Realización de la firma
     * @param {Firma} firma Firma a realizar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public firmar(firma: Firma, options?: any) {
        return FormalizacionApiFp(this.configuration).firmar(firma, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Realización de múltiples firmas
     * @summary Realización de múltiples firmas
     * @param {FirmaMultiple} firmas Firmas a realizar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public firmarMultiple(firmas: FirmaMultiple, options?: any) {
        return FormalizacionApiFp(this.configuration).firmarMultiple(firmas, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una página de convocatorias
     * @summary Obtiene una página de convocatorias
     * @param {string} [areaClave] Clave del area
     * @param {boolean} [activo] Indica si la convocatoria está acitva o no
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getAllConvocatorias(areaClave?: string, activo?: boolean, page?: number, size?: number, options?: any) {
        return FormalizacionApiFp(this.configuration).getAllConvocatorias(areaClave, activo, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene todos los firmables relacionados a la solicitud especificada.
     * @summary Obtiene todos los firmables relacionados a la solicitud especificada.
     * @param {string} solicitudClave La clave de la solicitud.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getAllFirmablesBySolicitud(solicitudClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getAllFirmablesBySolicitud(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una página de modalidades
     * @summary Obtiene una página de modalidades
     * @param {string} [convocatoriaClave] Clave de la convocatoria
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getAllModalidades(convocatoriaClave?: string, page?: number, size?: number, options?: any) {
        return FormalizacionApiFp(this.configuration).getAllModalidades(convocatoriaClave, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una página de notificaciones
     * @summary Obtiene una página de notificaciones
     * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
     * @param {boolean} [leido] Indica la notificación ha sido leia o no
     * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getAllNotificaciones(claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options?: any) {
        return FormalizacionApiFp(this.configuration).getAllNotificaciones(claveProyecto, leido, sort, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una página de procesos
     * @summary Obtiene una página de procesos
     * @param {string} [convocatoriaClave] Clave de la convocatoria
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getAllProcesos(convocatoriaClave?: string, page?: number, size?: number, options?: any) {
        return FormalizacionApiFp(this.configuration).getAllProcesos(convocatoriaClave, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
     * @summary Obtiene una página de solicitudes.
     * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
     * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
     * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
     * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
     * @param {string} [titulo] Título de la solicitud
     * @param {string} [numSolicitud] Numero de solicitud
     * @param {string} [participanteCvu] Numero de cvu del participante
     * @param {string} [institucionClave] Clave de la institución
     * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
     * @param {string} [fechaInicio] Fecha de inicio del proyecto
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
     * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getAllSolicitudes(convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options?: any) {
        return FormalizacionApiFp(this.configuration).getAllSolicitudes(convocatoriaClave, modalidadClave, procesoClave, estadoFormalizacion, titulo, numSolicitud, participanteCvu, institucionClave, areaConocimientoId, fechaInicio, page, size, sortBy, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera la cuenta bancaria asociada a la solicitud dada.
     * @summary Recupera la cuenta bancaria asociada a la solicitud.
     * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getApoyoEconomicoByParticipacion(solicitudId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getApoyoEconomicoByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Valida si el usuario actual puede firmar el documento especificado
     * @summary Valida si se puede firmar el documento
     * @param {string} firmableId Id del firmable que se requiere validar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getCanSign(firmableId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getCanSign(firmableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la convocatoria con la clave especificada
     * @summary Obtiene la convocatoria con la clave especificada
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getConvocatoria(convocatoriaClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getConvocatoria(convocatoriaClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el numero de firmas de la persona logueada
     * @summary Recupera el numero de firmas de la persona logueada
     * @param {string} [solicitudClave] Clave del documento asociado al firmable
     * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
     * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
     * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getCountFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, options?: any) {
        return FormalizacionApiFp(this.configuration).getCountFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el numero solicitudes
     * @summary Recupera el numero de solicitudes
     * @param {string} [claveConvocatoria] Clave de la convocatoria
     * @param {string} [claveModalidad] Clave de la modalidad
     * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
     * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getCountSolicitudes(claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options?: any) {
        return FormalizacionApiFp(this.configuration).getCountSolicitudes(claveConvocatoria, claveModalidad, procesoClave, estadoFormalizacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera la cuenta bancaria asociada a la solicitud dada.
     * @summary Recupera la cuenta bancaria asociada a la solicitud.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getCuentaBancariaByParticipacion(solicitudId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene las cuentas bancarias por validar pertenecientes a la convocatoria indicada.
     * @summary Obtiene las cuentas bancarias por validar.
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
     * @param {'por-validar'} estado Indica el estado de la cuenta bancaria.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getCuentasBancarias(convocatoriaClave: string, estado: 'por-validar', options?: any) {
        return FormalizacionApiFp(this.configuration).getCuentasBancarias(convocatoriaClave, estado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
     * @summary Obtiene los dependientes económicos de la solicitud especificada.
     * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getDependientesEconomicosByMe(solicitudId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getDependientesEconomicosByMe(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * El estado actual de la solicitud.
     * @summary El estado actual de la solicitud.
     * @param {string} solicitudClave Clave de la solicitud a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getEstadoFormalizacionBySolicitud(solicitudClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getEstadoFormalizacionBySolicitud(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
     * @summary Estados de formalizacion que puede consultar el usuario autenticado
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getEstadosFormalizacionByMe(options?: any) {
        return FormalizacionApiFp(this.configuration).getEstadosFormalizacionByMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una firma. Puede estar realizada o no
     * @summary Obtiene una firma
     * @param {string} firmableId Id del firmable a consultar
     * @param {string} rfc El número RFC del firmante
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getFirma(firmableId: string, rfc: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getFirma(firmableId, rfc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene las firmas firmable con id especificado
     * @summary Obtiene las firmas del firmable con id especificado
     * @param {string} firmableId Id del firmable a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getFirmaByIdFirmable(firmableId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getFirmaByIdFirmable(firmableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el firmable con id especificado
     * @summary Obtiene el firmable con id especificado
     * @param {string} firmableId Id del firmable a consultar
     * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getFirmableById(firmableId: string, representacionImpresa?: boolean, options?: any) {
        return FormalizacionApiFp(this.configuration).getFirmableById(firmableId, representacionImpresa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el firmable con id especificado
     * @summary Obtiene el firmable con id especificado
     * @param {string} solicitudClave Id del firmable a consultar
     * @param {ClasificacionFirmable} clasificacion Id del firmable a consultar
     * @param {boolean} [representacionImpresa] Indica si la respuesta debe contener la representación impresa del firmable.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getFirmableBySolicitudAndClase(solicitudClave: string, clasificacion: ClasificacionFirmable, representacionImpresa?: boolean, options?: any) {
        return FormalizacionApiFp(this.configuration).getFirmableBySolicitudAndClase(solicitudClave, clasificacion, representacionImpresa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene todas las firmas correspondientes al usuario en sesión
     * @summary Obtiene todas las firmas correspondientes al usuario en sesión
     * @param {string} [solicitudClave] Clave del documento asociado al firmable
     * @param {string} [convocatoriaClave] Clave de la convocatoria asociado al firmable
     * @param {Array<string>} [tiposDocumento] Firmas de acuerdo a los tipos de documento
     * @param {boolean} [sinFirmar] Indica si recupera solo los que falten por firmar
     * @param {boolean} [incluyeData] Indica incluye la cadena original para la firma
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getFirmasByMe(solicitudClave?: string, convocatoriaClave?: string, tiposDocumento?: Array<string>, sinFirmar?: boolean, incluyeData?: boolean, page?: number, size?: number, sort?: 'asc' | 'desc', options?: any) {
        return FormalizacionApiFp(this.configuration).getFirmasByMe(solicitudClave, convocatoriaClave, tiposDocumento, sinFirmar, incluyeData, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la modalidad con la clave especificada
     * @summary Obtiene la modalidad con la clave especificada
     * @param {string} modalidadClave Clave de la modalidad a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getModalidad(modalidadClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getModalidad(modalidadClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una lista de notificaciones
     * @summary Obtiene una lista de notificaciones
     * @param {string} notificacionId Notificación a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getNotificacion(notificacionId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getNotificacion(notificacionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la cantidad de documentos para la convocatoria
     * @summary Obtiene la cantidad de documentos para la convocatoria
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getNumDocumentosConvocatoria(convocatoriaClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getNumDocumentosConvocatoria(convocatoriaClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el numero solicitudes
     * @summary Recupera un arreglo con las participaciones que tiene el usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getParticipacionesSolicitudes(options?: any) {
        return FormalizacionApiFp(this.configuration).getParticipacionesSolicitudes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la proceso con la clave especificada
     * @summary Obtiene la proceso con la clave especificada
     * @param {string} procesoClave Clave de la proceso a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getProceso(procesoClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getProceso(procesoClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene todas las firmas correspondientes al usuario en sesión
     * @summary Obtiene todas las firmas correspondientes al usuario en sesión
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getReplacement(options?: any) {
        return FormalizacionApiFp(this.configuration).getReplacement(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la solicitud con la clave especificada
     * @summary Obtiene la solicitud con la clave especificada
     * @param {string} solicitudClave Clave de la solicitud a consultar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getSolicitud(solicitudClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).getSolicitud(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los estatus de las firmas correspondientes al usuario en la sesión
     * @summary Obtiene los estatus de las firmas correspondientes al usuario en la sesión
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getStatusFirmasByMe(options?: any) {
        return FormalizacionApiFp(this.configuration).getStatusFirmasByMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la última aclaración de la solicitud especificada.
     * @summary Obtiene la última aclaración de la solicitud especificada.
     * @param {string} solicitudClave Clave de la solicitud a consultar
     * @param {0} page Número de la pagina
     * @param {1} size Elementos por página
     * @param {'desc'} sort 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public getUltimaAclaracionBySolicitud(solicitudClave: string, page: 0, size: 1, sort: 'desc', options?: any) {
        return FormalizacionApiFp(this.configuration).getUltimaAclaracionBySolicitud(solicitudClave, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cambia el estado de la firma del usuario autenticado para iniciar el proceso de firma multiple
     * @summary Cambia el estado de la firma para iniciar el proceso de firma multiple
     * @param {string} firmableId Id del firmable en que se cambiará el estado
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public iniciaFirma(firmableId: string, options?: any) {
        return FormalizacionApiFp(this.configuration).iniciaFirma(firmableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
     * @summary Importa el archivo de validaciones de cuentas bancarias otorgado por el banco.
     * @param {string} convocatoriaClave Clave de la convocatoria a consultar.
     * @param {any} body Archivo con las validaciones otorgado por el banco. Una validación por fila con valores separados por el caracter pipe \&#39;|\&#39;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public loadValidacionCuentasBancarias(convocatoriaClave: string, body: any, options?: any) {
        return FormalizacionApiFp(this.configuration).loadValidacionCuentasBancarias(convocatoriaClave, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rechaza una aclaración abierta
     * @summary Rechaza una aclaración abierta
     * @param {string} aclaracionId El id de la aclaración.
     * @param {Comentario} [comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public rechazaAclaracionBySolicitud(aclaracionId: string, comentario?: Comentario, options?: any) {
        return FormalizacionApiFp(this.configuration).rechazaAclaracionBySolicitud(aclaracionId, comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
     * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
     * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
     * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public regeneraFirmables(solicitudId: string, deleteFirma: boolean, options?: any) {
        return FormalizacionApiFp(this.configuration).regeneraFirmables(solicitudId, deleteFirma, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
     * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
     * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
     * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public setApoyoEconomicoByParticipacion(solicitudId: string, apoyoEconomico: ApoyoEconomico, options?: any) {
        return FormalizacionApiFp(this.configuration).setApoyoEconomicoByParticipacion(solicitudId, apoyoEconomico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
     * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
     * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public setCuentaBancariaByParticipacion(solicitudId: string, cuentaBancaria: CuentaBancaria, options?: any) {
        return FormalizacionApiFp(this.configuration).setCuentaBancariaByParticipacion(solicitudId, cuentaBancaria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza los dependientes económicos de la solicitud dada.
     * @summary Actualiza los dependientes económicos de la participación.
     * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
     * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public updateDependientesEconomicosByMe(solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options?: any) {
        return FormalizacionApiFp(this.configuration).updateDependientesEconomicosByMe(solicitudId, dependienteEconomico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza estatus de la notificación
     * @summary Actualiza estatus de la notificación
     * @param {string} notificacionId Identificador de la notificación
     * @param {Notificacion} notificacion Notificación con los cambios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public updateEstatusNotificacion(notificacionId: string, notificacion: Notificacion, options?: any) {
        return FormalizacionApiFp(this.configuration).updateEstatusNotificacion(notificacionId, notificacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza la solicitud
     * @summary Actualiza la solicitud
     * @param {Solicitud} solicitud Solicitud con los cambios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public updateSolicitud(solicitud: Solicitud, options?: any) {
        return FormalizacionApiFp(this.configuration).updateSolicitud(solicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
     * @summary Indica que los documentos están validados por parte del solicitante.
     * @param {string} solicitudClave Clave de la solicitud a cambiar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormalizacionApi
     */
    public validaDocumentos(solicitudClave: string, options?: any) {
        return FormalizacionApiFp(this.configuration).validaDocumentos(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ModalidadApi - axios parameter creator
 * @export
 */
export const ModalidadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de modalidades
         * @summary Obtiene una página de modalidades
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModalidades: async (convocatoriaClave?: string, page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/modalidades`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la modalidad con la clave especificada
         * @summary Obtiene la modalidad con la clave especificada
         * @param {string} modalidadClave Clave de la modalidad a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModalidad: async (modalidadClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'modalidadClave' is not null or undefined
            if (modalidadClave === null || modalidadClave === undefined) {
                throw new RequiredError('modalidadClave','Required parameter modalidadClave was null or undefined when calling getModalidad.');
            }
            const localVarPath = `/modalidades/{modalidadClave}`
                .replace(`{${"modalidadClave"}}`, encodeURIComponent(String(modalidadClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModalidadApi - functional programming interface
 * @export
 */
export const ModalidadApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de modalidades
         * @summary Obtiene una página de modalidades
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllModalidades(convocatoriaClave?: string, page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Modalidad>>> {
            const localVarAxiosArgs = await ModalidadApiAxiosParamCreator(configuration).getAllModalidades(convocatoriaClave, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la modalidad con la clave especificada
         * @summary Obtiene la modalidad con la clave especificada
         * @param {string} modalidadClave Clave de la modalidad a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModalidad(modalidadClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modalidad>> {
            const localVarAxiosArgs = await ModalidadApiAxiosParamCreator(configuration).getModalidad(modalidadClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ModalidadApi - factory interface
 * @export
 */
export const ModalidadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtiene una página de modalidades
         * @summary Obtiene una página de modalidades
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModalidades(convocatoriaClave?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Modalidad>> {
            return ModalidadApiFp(configuration).getAllModalidades(convocatoriaClave, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la modalidad con la clave especificada
         * @summary Obtiene la modalidad con la clave especificada
         * @param {string} modalidadClave Clave de la modalidad a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModalidad(modalidadClave: string, options?: any): AxiosPromise<Modalidad> {
            return ModalidadApiFp(configuration).getModalidad(modalidadClave, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModalidadApi - object-oriented interface
 * @export
 * @class ModalidadApi
 * @extends {BaseAPI}
 */
export class ModalidadApi extends BaseAPI {
    /**
     * Obtiene una página de modalidades
     * @summary Obtiene una página de modalidades
     * @param {string} [convocatoriaClave] Clave de la convocatoria
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModalidadApi
     */
    public getAllModalidades(convocatoriaClave?: string, page?: number, size?: number, options?: any) {
        return ModalidadApiFp(this.configuration).getAllModalidades(convocatoriaClave, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la modalidad con la clave especificada
     * @summary Obtiene la modalidad con la clave especificada
     * @param {string} modalidadClave Clave de la modalidad a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModalidadApi
     */
    public getModalidad(modalidadClave: string, options?: any) {
        return ModalidadApiFp(this.configuration).getModalidad(modalidadClave, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotificacionApi - axios parameter creator
 * @export
 */
export const NotificacionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de notificaciones
         * @summary Obtiene una página de notificaciones
         * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
         * @param {boolean} [leido] Indica la notificación ha sido leia o no
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificaciones: async (claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/notificaciones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (claveProyecto !== undefined) {
                localVarQueryParameter['claveProyecto'] = claveProyecto;
            }

            if (leido !== undefined) {
                localVarQueryParameter['leido'] = leido;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una lista de notificaciones
         * @summary Obtiene una lista de notificaciones
         * @param {string} notificacionId Notificación a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificacion: async (notificacionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificacionId' is not null or undefined
            if (notificacionId === null || notificacionId === undefined) {
                throw new RequiredError('notificacionId','Required parameter notificacionId was null or undefined when calling getNotificacion.');
            }
            const localVarPath = `/notificaciones/{notificacionId}`
                .replace(`{${"notificacionId"}}`, encodeURIComponent(String(notificacionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza estatus de la notificación
         * @summary Actualiza estatus de la notificación
         * @param {string} notificacionId Identificador de la notificación
         * @param {Notificacion} notificacion Notificación con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEstatusNotificacion: async (notificacionId: string, notificacion: Notificacion, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificacionId' is not null or undefined
            if (notificacionId === null || notificacionId === undefined) {
                throw new RequiredError('notificacionId','Required parameter notificacionId was null or undefined when calling updateEstatusNotificacion.');
            }
            // verify required parameter 'notificacion' is not null or undefined
            if (notificacion === null || notificacion === undefined) {
                throw new RequiredError('notificacion','Required parameter notificacion was null or undefined when calling updateEstatusNotificacion.');
            }
            const localVarPath = `/notificaciones/{notificacionId}`
                .replace(`{${"notificacionId"}}`, encodeURIComponent(String(notificacionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof notificacion !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(notificacion !== undefined ? notificacion : {}) : (notificacion || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificacionApi - functional programming interface
 * @export
 */
export const NotificacionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de notificaciones
         * @summary Obtiene una página de notificaciones
         * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
         * @param {boolean} [leido] Indica la notificación ha sido leia o no
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotificaciones(claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notificacion>>> {
            const localVarAxiosArgs = await NotificacionApiAxiosParamCreator(configuration).getAllNotificaciones(claveProyecto, leido, sort, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una lista de notificaciones
         * @summary Obtiene una lista de notificaciones
         * @param {string} notificacionId Notificación a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificacion(notificacionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notificacion>> {
            const localVarAxiosArgs = await NotificacionApiAxiosParamCreator(configuration).getNotificacion(notificacionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Actualiza estatus de la notificación
         * @summary Actualiza estatus de la notificación
         * @param {string} notificacionId Identificador de la notificación
         * @param {Notificacion} notificacion Notificación con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEstatusNotificacion(notificacionId: string, notificacion: Notificacion, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NotificacionApiAxiosParamCreator(configuration).updateEstatusNotificacion(notificacionId, notificacion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificacionApi - factory interface
 * @export
 */
export const NotificacionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtiene una página de notificaciones
         * @summary Obtiene una página de notificaciones
         * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
         * @param {boolean} [leido] Indica la notificación ha sido leia o no
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificaciones(claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options?: any): AxiosPromise<Array<Notificacion>> {
            return NotificacionApiFp(configuration).getAllNotificaciones(claveProyecto, leido, sort, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una lista de notificaciones
         * @summary Obtiene una lista de notificaciones
         * @param {string} notificacionId Notificación a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificacion(notificacionId: string, options?: any): AxiosPromise<Notificacion> {
            return NotificacionApiFp(configuration).getNotificacion(notificacionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza estatus de la notificación
         * @summary Actualiza estatus de la notificación
         * @param {string} notificacionId Identificador de la notificación
         * @param {Notificacion} notificacion Notificación con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEstatusNotificacion(notificacionId: string, notificacion: Notificacion, options?: any): AxiosPromise<void> {
            return NotificacionApiFp(configuration).updateEstatusNotificacion(notificacionId, notificacion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificacionApi - object-oriented interface
 * @export
 * @class NotificacionApi
 * @extends {BaseAPI}
 */
export class NotificacionApi extends BaseAPI {
    /**
     * Obtiene una página de notificaciones
     * @summary Obtiene una página de notificaciones
     * @param {string} [claveProyecto] Clave del proyecto a la que pertenecen las notificaciones
     * @param {boolean} [leido] Indica la notificación ha sido leia o no
     * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificacionApi
     */
    public getAllNotificaciones(claveProyecto?: string, leido?: boolean, sort?: 'asc' | 'desc', page?: number, size?: number, options?: any) {
        return NotificacionApiFp(this.configuration).getAllNotificaciones(claveProyecto, leido, sort, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una lista de notificaciones
     * @summary Obtiene una lista de notificaciones
     * @param {string} notificacionId Notificación a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificacionApi
     */
    public getNotificacion(notificacionId: string, options?: any) {
        return NotificacionApiFp(this.configuration).getNotificacion(notificacionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza estatus de la notificación
     * @summary Actualiza estatus de la notificación
     * @param {string} notificacionId Identificador de la notificación
     * @param {Notificacion} notificacion Notificación con los cambios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificacionApi
     */
    public updateEstatusNotificacion(notificacionId: string, notificacion: Notificacion, options?: any) {
        return NotificacionApiFp(this.configuration).updateEstatusNotificacion(notificacionId, notificacion, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcesoApi - axios parameter creator
 * @export
 */
export const ProcesoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de procesos
         * @summary Obtiene una página de procesos
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProcesos: async (convocatoriaClave?: string, page?: number, size?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/procesos`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la proceso con la clave especificada
         * @summary Obtiene la proceso con la clave especificada
         * @param {string} procesoClave Clave de la proceso a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProceso: async (procesoClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'procesoClave' is not null or undefined
            if (procesoClave === null || procesoClave === undefined) {
                throw new RequiredError('procesoClave','Required parameter procesoClave was null or undefined when calling getProceso.');
            }
            const localVarPath = `/procesos/{procesoClave}`
                .replace(`{${"procesoClave"}}`, encodeURIComponent(String(procesoClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcesoApi - functional programming interface
 * @export
 */
export const ProcesoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Obtiene una página de procesos
         * @summary Obtiene una página de procesos
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProcesos(convocatoriaClave?: string, page?: number, size?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Proceso>>> {
            const localVarAxiosArgs = await ProcesoApiAxiosParamCreator(configuration).getAllProcesos(convocatoriaClave, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la proceso con la clave especificada
         * @summary Obtiene la proceso con la clave especificada
         * @param {string} procesoClave Clave de la proceso a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProceso(procesoClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Proceso>> {
            const localVarAxiosArgs = await ProcesoApiAxiosParamCreator(configuration).getProceso(procesoClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcesoApi - factory interface
 * @export
 */
export const ProcesoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtiene una página de procesos
         * @summary Obtiene una página de procesos
         * @param {string} [convocatoriaClave] Clave de la convocatoria
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProcesos(convocatoriaClave?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Proceso>> {
            return ProcesoApiFp(configuration).getAllProcesos(convocatoriaClave, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la proceso con la clave especificada
         * @summary Obtiene la proceso con la clave especificada
         * @param {string} procesoClave Clave de la proceso a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProceso(procesoClave: string, options?: any): AxiosPromise<Proceso> {
            return ProcesoApiFp(configuration).getProceso(procesoClave, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcesoApi - object-oriented interface
 * @export
 * @class ProcesoApi
 * @extends {BaseAPI}
 */
export class ProcesoApi extends BaseAPI {
    /**
     * Obtiene una página de procesos
     * @summary Obtiene una página de procesos
     * @param {string} [convocatoriaClave] Clave de la convocatoria
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcesoApi
     */
    public getAllProcesos(convocatoriaClave?: string, page?: number, size?: number, options?: any) {
        return ProcesoApiFp(this.configuration).getAllProcesos(convocatoriaClave, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la proceso con la clave especificada
     * @summary Obtiene la proceso con la clave especificada
     * @param {string} procesoClave Clave de la proceso a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcesoApi
     */
    public getProceso(procesoClave: string, options?: any) {
        return ProcesoApiFp(this.configuration).getProceso(procesoClave, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SolicitanteApi - axios parameter creator
 * @export
 */
export const SolicitanteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
         * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agregaSolicitanteComplemento: async (solicitanteComplemento: SolicitanteComplemento, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitanteComplemento' is not null or undefined
            if (solicitanteComplemento === null || solicitanteComplemento === undefined) {
                throw new RequiredError('solicitanteComplemento','Required parameter solicitanteComplemento was null or undefined when calling agregaSolicitanteComplemento.');
            }
            const localVarPath = `/solicitante-complemento`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof solicitanteComplemento !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(solicitanteComplemento !== undefined ? solicitanteComplemento : {}) : (solicitanteComplemento || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        borraSolicitanteComplemento: async (cvu: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            if (cvu === null || cvu === undefined) {
                throw new RequiredError('cvu','Required parameter cvu was null or undefined when calling borraSolicitanteComplemento.');
            }
            const localVarPath = `/solicitante-complemento/{cvu}`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buscarSolicitanteComplementoByCvu: async (cvu: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            if (cvu === null || cvu === undefined) {
                throw new RequiredError('cvu','Required parameter cvu was null or undefined when calling buscarSolicitanteComplementoByCvu.');
            }
            const localVarPath = `/solicitante-complemento/{cvu}`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SolicitanteApi - functional programming interface
 * @export
 */
export const SolicitanteApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
         * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agregaSolicitanteComplemento(solicitanteComplemento: SolicitanteComplemento, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitanteApiAxiosParamCreator(configuration).agregaSolicitanteComplemento(solicitanteComplemento, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async borraSolicitanteComplemento(cvu: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitanteApiAxiosParamCreator(configuration).borraSolicitanteComplemento(cvu, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buscarSolicitanteComplementoByCvu(cvu: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolicitanteComplemento>> {
            const localVarAxiosArgs = await SolicitanteApiAxiosParamCreator(configuration).buscarSolicitanteComplementoByCvu(cvu, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SolicitanteApi - factory interface
 * @export
 */
export const SolicitanteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
         * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agregaSolicitanteComplemento(solicitanteComplemento: SolicitanteComplemento, options?: any): AxiosPromise<void> {
            return SolicitanteApiFp(configuration).agregaSolicitanteComplemento(solicitanteComplemento, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        borraSolicitanteComplemento(cvu: string, options?: any): AxiosPromise<void> {
            return SolicitanteApiFp(configuration).borraSolicitanteComplemento(cvu, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Busca información extra de un solicitante por su CVU
         * @param {string} cvu 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buscarSolicitanteComplementoByCvu(cvu: string, options?: any): AxiosPromise<SolicitanteComplemento> {
            return SolicitanteApiFp(configuration).buscarSolicitanteComplementoByCvu(cvu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SolicitanteApi - object-oriented interface
 * @export
 * @class SolicitanteApi
 * @extends {BaseAPI}
 */
export class SolicitanteApi extends BaseAPI {
    /**
     * 
     * @summary Agrega información extra de un solicitante (reemplaza la información del anterior)
     * @param {SolicitanteComplemento} solicitanteComplemento Información del extra solicitante.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitanteApi
     */
    public agregaSolicitanteComplemento(solicitanteComplemento: SolicitanteComplemento, options?: any) {
        return SolicitanteApiFp(this.configuration).agregaSolicitanteComplemento(solicitanteComplemento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Busca información extra de un solicitante por su CVU
     * @param {string} cvu 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitanteApi
     */
    public borraSolicitanteComplemento(cvu: string, options?: any) {
        return SolicitanteApiFp(this.configuration).borraSolicitanteComplemento(cvu, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Busca información extra de un solicitante por su CVU
     * @param {string} cvu 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitanteApi
     */
    public buscarSolicitanteComplementoByCvu(cvu: string, options?: any) {
        return SolicitanteApiFp(this.configuration).buscarSolicitanteComplementoByCvu(cvu, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SolicitudApi - axios parameter creator
 * @export
 */
export const SolicitudApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Acepta la aclaración y aplica la modificación.
         * @summary Acepta la aclaración.
         * @param {string} aclaracionId El id de la aclaración.
         * @param {AceptacionAclaracion} [aceptacionAclaracion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aceptarAclaracionBySolicitud: async (aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'aclaracionId' is not null or undefined
            if (aclaracionId === null || aclaracionId === undefined) {
                throw new RequiredError('aclaracionId','Required parameter aclaracionId was null or undefined when calling aceptarAclaracionBySolicitud.');
            }
            const localVarPath = `/aclaraciones/{aclaracionId}/aceptacion`
                .replace(`{${"aclaracionId"}}`, encodeURIComponent(String(aclaracionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof aceptacionAclaracion !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(aceptacionAclaracion !== undefined ? aceptacionAclaracion : {}) : (aceptacionAclaracion || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancela una solicitud dada una clave
         * @summary Cancela una solicitud dada una clave
         * @param {string} solicitudId Id de la solicitud a cancelar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSolicitudById: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling cancelSolicitudById.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/cancel`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirma la información de la cuenta bancaria.
         * @summary Confirma la información de la cuenta bancaria.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmaCuentaBancariaByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling confirmaCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria/confirm`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
         * @summary Crea una aclaración o comenta sobre la actual.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearAclaracionBySolicitud: async (solicitudClave: string, comentario?: Comentario, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling crearAclaracionBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/aclaraciones`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof comentario !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(comentario !== undefined ? comentario : {}) : (comentario || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crea una nueva solicitud a formalizar
         * @summary Crea una nueva solicitud a formalizar
         * @param {Solicitud} solicitud La solicitud a crear.
         * @param {boolean} [async] Indica si la petición es asíncrona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolicitud: async (solicitud: Solicitud, async?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitud' is not null or undefined
            if (solicitud === null || solicitud === undefined) {
                throw new RequiredError('solicitud','Required parameter solicitud was null or undefined when calling createSolicitud.');
            }
            const localVarPath = `/solicitudes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (async !== undefined) {
                localVarQueryParameter['async'] = async;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof solicitud !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(solicitud !== undefined ? solicitud : {}) : (solicitud || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Borra la cuenta bancaria asociada a la solicitud dada.
         * @summary Borra la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCuentaBancariaByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling deleteCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
         * @summary Obtiene una página de solicitudes.
         * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [titulo] Título de la solicitud
         * @param {string} [numSolicitud] Numero de solicitud
         * @param {string} [participanteCvu] Numero de cvu del participante
         * @param {string} [institucionClave] Clave de la institución
         * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
         * @param {string} [fechaInicio] Fecha de inicio del proyecto
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudes: async (convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (convocatoriaClave !== undefined) {
                localVarQueryParameter['convocatoriaClave'] = convocatoriaClave;
            }

            if (modalidadClave !== undefined) {
                localVarQueryParameter['modalidadClave'] = modalidadClave;
            }

            if (procesoClave !== undefined) {
                localVarQueryParameter['procesoClave'] = procesoClave;
            }

            if (estadoFormalizacion !== undefined) {
                localVarQueryParameter['estadoFormalizacion'] = estadoFormalizacion;
            }

            if (titulo !== undefined) {
                localVarQueryParameter['titulo'] = titulo;
            }

            if (numSolicitud !== undefined) {
                localVarQueryParameter['numSolicitud'] = numSolicitud;
            }

            if (participanteCvu !== undefined) {
                localVarQueryParameter['participanteCvu'] = participanteCvu;
            }

            if (institucionClave !== undefined) {
                localVarQueryParameter['institucionClave'] = institucionClave;
            }

            if (areaConocimientoId !== undefined) {
                localVarQueryParameter['areaConocimientoId'] = areaConocimientoId;
            }

            if (fechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (fechaInicio as any instanceof Date) ?
                    (fechaInicio as any).toISOString().substr(0,10) :
                    fechaInicio;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApoyoEconomicoByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling getApoyoEconomicoByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera el numero de solicitudes
         * @param {string} [claveConvocatoria] Clave de la convocatoria
         * @param {string} [claveModalidad] Clave de la modalidad
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountSolicitudes: async (claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/count`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (claveConvocatoria !== undefined) {
                localVarQueryParameter['claveConvocatoria'] = claveConvocatoria;
            }

            if (claveModalidad !== undefined) {
                localVarQueryParameter['claveModalidad'] = claveModalidad;
            }

            if (procesoClave !== undefined) {
                localVarQueryParameter['procesoClave'] = procesoClave;
            }

            if (estadoFormalizacion !== undefined) {
                localVarQueryParameter['estadoFormalizacion'] = estadoFormalizacion;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentaBancariaByParticipacion: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling getCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
         * @summary Obtiene los dependientes económicos de la solicitud especificada.
         * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependientesEconomicosByMe: async (solicitudId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling getDependientesEconomicosByMe.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/dependientes-economicos`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * El estado actual de la solicitud.
         * @summary El estado actual de la solicitud.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadoFormalizacionBySolicitud: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getEstadoFormalizacionBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/estadoFormalizacion`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
         * @summary Estados de formalizacion que puede consultar el usuario autenticado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadosFormalizacionByMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/estadosFormalizacionByMe`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera un arreglo con las participaciones que tiene el usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipacionesSolicitudes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/participaciones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la solicitud con la clave especificada
         * @summary Obtiene la solicitud con la clave especificada
         * @param {string} solicitudClave Clave de la solicitud a consultar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitud: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getSolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene la última aclaración de la solicitud especificada.
         * @summary Obtiene la última aclaración de la solicitud especificada.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {0} page Número de la pagina
         * @param {1} size Elementos por página
         * @param {'desc'} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUltimaAclaracionBySolicitud: async (solicitudClave: string, page: 0, size: 1, sort: 'desc', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            // verify required parameter 'sort' is not null or undefined
            if (sort === null || sort === undefined) {
                throw new RequiredError('sort','Required parameter sort was null or undefined when calling getUltimaAclaracionBySolicitud.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/aclaraciones`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rechaza una aclaración abierta
         * @summary Rechaza una aclaración abierta
         * @param {string} aclaracionId El id de la aclaración.
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazaAclaracionBySolicitud: async (aclaracionId: string, comentario?: Comentario, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'aclaracionId' is not null or undefined
            if (aclaracionId === null || aclaracionId === undefined) {
                throw new RequiredError('aclaracionId','Required parameter aclaracionId was null or undefined when calling rechazaAclaracionBySolicitud.');
            }
            const localVarPath = `/aclaraciones/{aclaracionId}/rechazo`
                .replace(`{${"aclaracionId"}}`, encodeURIComponent(String(aclaracionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof comentario !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(comentario !== undefined ? comentario : {}) : (comentario || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
         * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
         * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
         * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneraFirmables: async (solicitudId: string, deleteFirma: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling regeneraFirmables.');
            }
            // verify required parameter 'deleteFirma' is not null or undefined
            if (deleteFirma === null || deleteFirma === undefined) {
                throw new RequiredError('deleteFirma','Required parameter deleteFirma was null or undefined when calling regeneraFirmables.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/regenera-firmables`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required

            if (deleteFirma !== undefined) {
                localVarQueryParameter['deleteFirma'] = deleteFirma;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
         * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setApoyoEconomicoByParticipacion: async (solicitudId: string, apoyoEconomico: ApoyoEconomico, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling setApoyoEconomicoByParticipacion.');
            }
            // verify required parameter 'apoyoEconomico' is not null or undefined
            if (apoyoEconomico === null || apoyoEconomico === undefined) {
                throw new RequiredError('apoyoEconomico','Required parameter apoyoEconomico was null or undefined when calling setApoyoEconomicoByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof apoyoEconomico !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(apoyoEconomico !== undefined ? apoyoEconomico : {}) : (apoyoEconomico || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCuentaBancariaByParticipacion: async (solicitudId: string, cuentaBancaria: CuentaBancaria, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling setCuentaBancariaByParticipacion.');
            }
            // verify required parameter 'cuentaBancaria' is not null or undefined
            if (cuentaBancaria === null || cuentaBancaria === undefined) {
                throw new RequiredError('cuentaBancaria','Required parameter cuentaBancaria was null or undefined when calling setCuentaBancariaByParticipacion.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/apoyo-economico/cuenta-bancaria`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cuentaBancaria !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cuentaBancaria !== undefined ? cuentaBancaria : {}) : (cuentaBancaria || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza los dependientes económicos de la solicitud dada.
         * @summary Actualiza los dependientes económicos de la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
         * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependientesEconomicosByMe: async (solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudId' is not null or undefined
            if (solicitudId === null || solicitudId === undefined) {
                throw new RequiredError('solicitudId','Required parameter solicitudId was null or undefined when calling updateDependientesEconomicosByMe.');
            }
            // verify required parameter 'dependienteEconomico' is not null or undefined
            if (dependienteEconomico === null || dependienteEconomico === undefined) {
                throw new RequiredError('dependienteEconomico','Required parameter dependienteEconomico was null or undefined when calling updateDependientesEconomicosByMe.');
            }
            const localVarPath = `/solicitudes/{solicitudId}/dependientes-economicos`
                .replace(`{${"solicitudId"}}`, encodeURIComponent(String(solicitudId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof dependienteEconomico !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(dependienteEconomico !== undefined ? dependienteEconomico : {}) : (dependienteEconomico || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza la solicitud
         * @summary Actualiza la solicitud
         * @param {Solicitud} solicitud Solicitud con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSolicitud: async (solicitud: Solicitud, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitud' is not null or undefined
            if (solicitud === null || solicitud === undefined) {
                throw new RequiredError('solicitud','Required parameter solicitud was null or undefined when calling updateSolicitud.');
            }
            const localVarPath = `/solicitudes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof solicitud !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(solicitud !== undefined ? solicitud : {}) : (solicitud || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
         * @summary Indica que los documentos están validados por parte del solicitante.
         * @param {string} solicitudClave Clave de la solicitud a cambiar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentos: async (solicitudClave: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitudClave' is not null or undefined
            if (solicitudClave === null || solicitudClave === undefined) {
                throw new RequiredError('solicitudClave','Required parameter solicitudClave was null or undefined when calling validaDocumentos.');
            }
            const localVarPath = `/solicitudes/{solicitudClave}/valida-documentos`
                .replace(`{${"solicitudClave"}}`, encodeURIComponent(String(solicitudClave)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SolicitudApi - functional programming interface
 * @export
 */
export const SolicitudApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Acepta la aclaración y aplica la modificación.
         * @summary Acepta la aclaración.
         * @param {string} aclaracionId El id de la aclaración.
         * @param {AceptacionAclaracion} [aceptacionAclaracion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aceptarAclaracionBySolicitud(aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).aceptarAclaracionBySolicitud(aclaracionId, aceptacionAclaracion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancela una solicitud dada una clave
         * @summary Cancela una solicitud dada una clave
         * @param {string} solicitudId Id de la solicitud a cancelar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSolicitudById(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).cancelSolicitudById(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirma la información de la cuenta bancaria.
         * @summary Confirma la información de la cuenta bancaria.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmaCuentaBancariaByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).confirmaCuentaBancariaByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
         * @summary Crea una aclaración o comenta sobre la actual.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crearAclaracionBySolicitud(solicitudClave: string, comentario?: Comentario, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).crearAclaracionBySolicitud(solicitudClave, comentario, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Crea una nueva solicitud a formalizar
         * @summary Crea una nueva solicitud a formalizar
         * @param {Solicitud} solicitud La solicitud a crear.
         * @param {boolean} [async] Indica si la petición es asíncrona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSolicitud(solicitud: Solicitud, async?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).createSolicitud(solicitud, async, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Borra la cuenta bancaria asociada a la solicitud dada.
         * @summary Borra la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCuentaBancariaByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).deleteCuentaBancariaByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
         * @summary Obtiene una página de solicitudes.
         * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [titulo] Título de la solicitud
         * @param {string} [numSolicitud] Numero de solicitud
         * @param {string} [participanteCvu] Numero de cvu del participante
         * @param {string} [institucionClave] Clave de la institución
         * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
         * @param {string} [fechaInicio] Fecha de inicio del proyecto
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSolicitudes(convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SolicitudBrief>>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getAllSolicitudes(convocatoriaClave, modalidadClave, procesoClave, estadoFormalizacion, titulo, numSolicitud, participanteCvu, institucionClave, areaConocimientoId, fechaInicio, page, size, sortBy, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApoyoEconomicoByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApoyoEconomico>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getApoyoEconomicoByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera el numero de solicitudes
         * @param {string} [claveConvocatoria] Clave de la convocatoria
         * @param {string} [claveModalidad] Clave de la modalidad
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountSolicitudes(claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getCountSolicitudes(claveConvocatoria, claveModalidad, procesoClave, estadoFormalizacion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCuentaBancariaByParticipacion(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CuentaBancaria>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getCuentaBancariaByParticipacion(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
         * @summary Obtiene los dependientes económicos de la solicitud especificada.
         * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependientesEconomicosByMe(solicitudId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DependienteEconomico>>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getDependientesEconomicosByMe(solicitudId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * El estado actual de la solicitud.
         * @summary El estado actual de la solicitud.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadoFormalizacionBySolicitud(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstadoFormalizacion>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getEstadoFormalizacionBySolicitud(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
         * @summary Estados de formalizacion que puede consultar el usuario autenticado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadosFormalizacionByMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EstadoFormalizacion>>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getEstadosFormalizacionByMe(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera un arreglo con las participaciones que tiene el usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParticipacionesSolicitudes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParticipacionCount>>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getParticipacionesSolicitudes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la solicitud con la clave especificada
         * @summary Obtiene la solicitud con la clave especificada
         * @param {string} solicitudClave Clave de la solicitud a consultar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolicitud(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Solicitud>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getSolicitud(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtiene la última aclaración de la solicitud especificada.
         * @summary Obtiene la última aclaración de la solicitud especificada.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {0} page Número de la pagina
         * @param {1} size Elementos por página
         * @param {'desc'} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUltimaAclaracionBySolicitud(solicitudClave: string, page: 0, size: 1, sort: 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Aclaracion>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).getUltimaAclaracionBySolicitud(solicitudClave, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Rechaza una aclaración abierta
         * @summary Rechaza una aclaración abierta
         * @param {string} aclaracionId El id de la aclaración.
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechazaAclaracionBySolicitud(aclaracionId: string, comentario?: Comentario, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).rechazaAclaracionBySolicitud(aclaracionId, comentario, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
         * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
         * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
         * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regeneraFirmables(solicitudId: string, deleteFirma: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Firmable>>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).regeneraFirmables(solicitudId, deleteFirma, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
         * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setApoyoEconomicoByParticipacion(solicitudId: string, apoyoEconomico: ApoyoEconomico, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).setApoyoEconomicoByParticipacion(solicitudId, apoyoEconomico, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCuentaBancariaByParticipacion(solicitudId: string, cuentaBancaria: CuentaBancaria, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).setCuentaBancariaByParticipacion(solicitudId, cuentaBancaria, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Actualiza los dependientes económicos de la solicitud dada.
         * @summary Actualiza los dependientes económicos de la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
         * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDependientesEconomicosByMe(solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).updateDependientesEconomicosByMe(solicitudId, dependienteEconomico, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Actualiza la solicitud
         * @summary Actualiza la solicitud
         * @param {Solicitud} solicitud Solicitud con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSolicitud(solicitud: Solicitud, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).updateSolicitud(solicitud, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
         * @summary Indica que los documentos están validados por parte del solicitante.
         * @param {string} solicitudClave Clave de la solicitud a cambiar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentos(solicitudClave: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SolicitudApiAxiosParamCreator(configuration).validaDocumentos(solicitudClave, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SolicitudApi - factory interface
 * @export
 */
export const SolicitudApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Acepta la aclaración y aplica la modificación.
         * @summary Acepta la aclaración.
         * @param {string} aclaracionId El id de la aclaración.
         * @param {AceptacionAclaracion} [aceptacionAclaracion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aceptarAclaracionBySolicitud(aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).aceptarAclaracionBySolicitud(aclaracionId, aceptacionAclaracion, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancela una solicitud dada una clave
         * @summary Cancela una solicitud dada una clave
         * @param {string} solicitudId Id de la solicitud a cancelar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSolicitudById(solicitudId: string, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).cancelSolicitudById(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirma la información de la cuenta bancaria.
         * @summary Confirma la información de la cuenta bancaria.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmaCuentaBancariaByParticipacion(solicitudId: string, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).confirmaCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
         * @summary Crea una aclaración o comenta sobre la actual.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearAclaracionBySolicitud(solicitudClave: string, comentario?: Comentario, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).crearAclaracionBySolicitud(solicitudClave, comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * Crea una nueva solicitud a formalizar
         * @summary Crea una nueva solicitud a formalizar
         * @param {Solicitud} solicitud La solicitud a crear.
         * @param {boolean} [async] Indica si la petición es asíncrona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolicitud(solicitud: Solicitud, async?: boolean, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).createSolicitud(solicitud, async, options).then((request) => request(axios, basePath));
        },
        /**
         * Borra la cuenta bancaria asociada a la solicitud dada.
         * @summary Borra la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCuentaBancariaByParticipacion(solicitudId: string, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).deleteCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
         * @summary Obtiene una página de solicitudes.
         * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
         * @param {string} [titulo] Título de la solicitud
         * @param {string} [numSolicitud] Numero de solicitud
         * @param {string} [participanteCvu] Numero de cvu del participante
         * @param {string} [institucionClave] Clave de la institución
         * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
         * @param {string} [fechaInicio] Fecha de inicio del proyecto
         * @param {number} [page] Numero de la pagina
         * @param {number} [size] Elementos por pagina
         * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
         * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudes(convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options?: any): AxiosPromise<Array<SolicitudBrief>> {
            return SolicitudApiFp(configuration).getAllSolicitudes(convocatoriaClave, modalidadClave, procesoClave, estadoFormalizacion, titulo, numSolicitud, participanteCvu, institucionClave, areaConocimientoId, fechaInicio, page, size, sortBy, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApoyoEconomicoByParticipacion(solicitudId: string, options?: any): AxiosPromise<ApoyoEconomico> {
            return SolicitudApiFp(configuration).getApoyoEconomicoByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera el numero de solicitudes
         * @param {string} [claveConvocatoria] Clave de la convocatoria
         * @param {string} [claveModalidad] Clave de la modalidad
         * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
         * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountSolicitudes(claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options?: any): AxiosPromise<number> {
            return SolicitudApiFp(configuration).getCountSolicitudes(claveConvocatoria, claveModalidad, procesoClave, estadoFormalizacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera la cuenta bancaria asociada a la solicitud dada.
         * @summary Recupera la cuenta bancaria asociada a la solicitud.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuentaBancariaByParticipacion(solicitudId: string, options?: any): AxiosPromise<CuentaBancaria> {
            return SolicitudApiFp(configuration).getCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
         * @summary Obtiene los dependientes económicos de la solicitud especificada.
         * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependientesEconomicosByMe(solicitudId: string, options?: any): AxiosPromise<Array<DependienteEconomico>> {
            return SolicitudApiFp(configuration).getDependientesEconomicosByMe(solicitudId, options).then((request) => request(axios, basePath));
        },
        /**
         * El estado actual de la solicitud.
         * @summary El estado actual de la solicitud.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadoFormalizacionBySolicitud(solicitudClave: string, options?: any): AxiosPromise<EstadoFormalizacion> {
            return SolicitudApiFp(configuration).getEstadoFormalizacionBySolicitud(solicitudClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
         * @summary Estados de formalizacion que puede consultar el usuario autenticado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadosFormalizacionByMe(options?: any): AxiosPromise<Array<EstadoFormalizacion>> {
            return SolicitudApiFp(configuration).getEstadosFormalizacionByMe(options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el numero solicitudes
         * @summary Recupera un arreglo con las participaciones que tiene el usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipacionesSolicitudes(options?: any): AxiosPromise<Array<ParticipacionCount>> {
            return SolicitudApiFp(configuration).getParticipacionesSolicitudes(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la solicitud con la clave especificada
         * @summary Obtiene la solicitud con la clave especificada
         * @param {string} solicitudClave Clave de la solicitud a consultar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitud(solicitudClave: string, options?: any): AxiosPromise<Solicitud> {
            return SolicitudApiFp(configuration).getSolicitud(solicitudClave, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene la última aclaración de la solicitud especificada.
         * @summary Obtiene la última aclaración de la solicitud especificada.
         * @param {string} solicitudClave Clave de la solicitud a consultar
         * @param {0} page Número de la pagina
         * @param {1} size Elementos por página
         * @param {'desc'} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUltimaAclaracionBySolicitud(solicitudClave: string, page: 0, size: 1, sort: 'desc', options?: any): AxiosPromise<Aclaracion> {
            return SolicitudApiFp(configuration).getUltimaAclaracionBySolicitud(solicitudClave, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Rechaza una aclaración abierta
         * @summary Rechaza una aclaración abierta
         * @param {string} aclaracionId El id de la aclaración.
         * @param {Comentario} [comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazaAclaracionBySolicitud(aclaracionId: string, comentario?: Comentario, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).rechazaAclaracionBySolicitud(aclaracionId, comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
         * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
         * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
         * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneraFirmables(solicitudId: string, deleteFirma: boolean, options?: any): AxiosPromise<Array<Firmable>> {
            return SolicitudApiFp(configuration).regeneraFirmables(solicitudId, deleteFirma, options).then((request) => request(axios, basePath));
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
         * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setApoyoEconomicoByParticipacion(solicitudId: string, apoyoEconomico: ApoyoEconomico, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).setApoyoEconomicoByParticipacion(solicitudId, apoyoEconomico, options).then((request) => request(axios, basePath));
        },
        /**
         * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
         * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
         * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
         * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCuentaBancariaByParticipacion(solicitudId: string, cuentaBancaria: CuentaBancaria, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).setCuentaBancariaByParticipacion(solicitudId, cuentaBancaria, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza los dependientes económicos de la solicitud dada.
         * @summary Actualiza los dependientes económicos de la participación.
         * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
         * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependientesEconomicosByMe(solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).updateDependientesEconomicosByMe(solicitudId, dependienteEconomico, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza la solicitud
         * @summary Actualiza la solicitud
         * @param {Solicitud} solicitud Solicitud con los cambios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSolicitud(solicitud: Solicitud, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).updateSolicitud(solicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
         * @summary Indica que los documentos están validados por parte del solicitante.
         * @param {string} solicitudClave Clave de la solicitud a cambiar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentos(solicitudClave: string, options?: any): AxiosPromise<void> {
            return SolicitudApiFp(configuration).validaDocumentos(solicitudClave, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SolicitudApi - object-oriented interface
 * @export
 * @class SolicitudApi
 * @extends {BaseAPI}
 */
export class SolicitudApi extends BaseAPI {
    /**
     * Acepta la aclaración y aplica la modificación.
     * @summary Acepta la aclaración.
     * @param {string} aclaracionId El id de la aclaración.
     * @param {AceptacionAclaracion} [aceptacionAclaracion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public aceptarAclaracionBySolicitud(aclaracionId: string, aceptacionAclaracion?: AceptacionAclaracion, options?: any) {
        return SolicitudApiFp(this.configuration).aceptarAclaracionBySolicitud(aclaracionId, aceptacionAclaracion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancela una solicitud dada una clave
     * @summary Cancela una solicitud dada una clave
     * @param {string} solicitudId Id de la solicitud a cancelar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public cancelSolicitudById(solicitudId: string, options?: any) {
        return SolicitudApiFp(this.configuration).cancelSolicitudById(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirma la información de la cuenta bancaria.
     * @summary Confirma la información de la cuenta bancaria.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public confirmaCuentaBancariaByParticipacion(solicitudId: string, options?: any) {
        return SolicitudApiFp(this.configuration).confirmaCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crea una aclaración sobre la solicitud especificada o agrega un comentario a la aclaración actualmente activa si ya existe una.
     * @summary Crea una aclaración o comenta sobre la actual.
     * @param {string} solicitudClave Clave de la solicitud a consultar
     * @param {Comentario} [comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public crearAclaracionBySolicitud(solicitudClave: string, comentario?: Comentario, options?: any) {
        return SolicitudApiFp(this.configuration).crearAclaracionBySolicitud(solicitudClave, comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crea una nueva solicitud a formalizar
     * @summary Crea una nueva solicitud a formalizar
     * @param {Solicitud} solicitud La solicitud a crear.
     * @param {boolean} [async] Indica si la petición es asíncrona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public createSolicitud(solicitud: Solicitud, async?: boolean, options?: any) {
        return SolicitudApiFp(this.configuration).createSolicitud(solicitud, async, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Borra la cuenta bancaria asociada a la solicitud dada.
     * @summary Borra la cuenta bancaria asociada a la participación.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta eliminar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public deleteCuentaBancariaByParticipacion(solicitudId: string, options?: any) {
        return SolicitudApiFp(this.configuration).deleteCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una página de solicitudes de acuerdo al rol: - Si el rol es externo, solo regresa los solicitudes en los que el usuario tiene una participación. - Si el rol es un usuario interno, regresa los solicitudes de las convocatorias de su area y a los que apliquee su puesto. - Si el rol es `admin`, regresa todos los solicitudes. 
     * @summary Obtiene una página de solicitudes.
     * @param {string} [convocatoriaClave] Clave de la convocatoria a la que pertenecen los solicitudes.
     * @param {string} [modalidadClave] Clave de la modalidad a la que pertenecen los solicitudes.
     * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
     * @param {EstadoFormalizacion} [estadoFormalizacion] Clave de la convocatoria a la que pertenecen los solicitudes.
     * @param {string} [titulo] Título de la solicitud
     * @param {string} [numSolicitud] Numero de solicitud
     * @param {string} [participanteCvu] Numero de cvu del participante
     * @param {string} [institucionClave] Clave de la institución
     * @param {number} [areaConocimientoId] Id del área de conocimiento de la solicitud
     * @param {string} [fechaInicio] Fecha de inicio del proyecto
     * @param {number} [page] Numero de la pagina
     * @param {number} [size] Elementos por pagina
     * @param {'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion'} [sortBy] Ordenado por uno de los elementos disponibles para ordenado.
     * @param {'asc' | 'desc'} [sort] Sort order:  * &#x60;asc&#x60; - Ascending, from A to Z  * &#x60;desc&#x60; - Descending, from Z to A 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getAllSolicitudes(convocatoriaClave?: string, modalidadClave?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, titulo?: string, numSolicitud?: string, participanteCvu?: string, institucionClave?: string, areaConocimientoId?: number, fechaInicio?: string, page?: number, size?: number, sortBy?: 'clave' | 'num_solicitud' | 'titulo' | 'solicitante_clave' | 'institucion_clave' | 'estado_formalizacion', sort?: 'asc' | 'desc', options?: any) {
        return SolicitudApiFp(this.configuration).getAllSolicitudes(convocatoriaClave, modalidadClave, procesoClave, estadoFormalizacion, titulo, numSolicitud, participanteCvu, institucionClave, areaConocimientoId, fechaInicio, page, size, sortBy, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera la cuenta bancaria asociada a la solicitud dada.
     * @summary Recupera la cuenta bancaria asociada a la solicitud.
     * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta recuperar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getApoyoEconomicoByParticipacion(solicitudId: string, options?: any) {
        return SolicitudApiFp(this.configuration).getApoyoEconomicoByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el numero solicitudes
     * @summary Recupera el numero de solicitudes
     * @param {string} [claveConvocatoria] Clave de la convocatoria
     * @param {string} [claveModalidad] Clave de la modalidad
     * @param {string} [procesoClave] Clave del proceso al que pertenecen los solicitudes.
     * @param {EstadoFormalizacion} [estadoFormalizacion] Estado de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getCountSolicitudes(claveConvocatoria?: string, claveModalidad?: string, procesoClave?: string, estadoFormalizacion?: EstadoFormalizacion, options?: any) {
        return SolicitudApiFp(this.configuration).getCountSolicitudes(claveConvocatoria, claveModalidad, procesoClave, estadoFormalizacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera la cuenta bancaria asociada a la solicitud dada.
     * @summary Recupera la cuenta bancaria asociada a la solicitud.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta recuperar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getCuentaBancariaByParticipacion(solicitudId: string, options?: any) {
        return SolicitudApiFp(this.configuration).getCuentaBancariaByParticipacion(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los dependientes económicos de la solicitud especificada para el usuario autenticado.
     * @summary Obtiene los dependientes económicos de la solicitud especificada.
     * @param {string} solicitudId Id de la solicitud al que pertenece la participación a recuperar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getDependientesEconomicosByMe(solicitudId: string, options?: any) {
        return SolicitudApiFp(this.configuration).getDependientesEconomicosByMe(solicitudId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * El estado actual de la solicitud.
     * @summary El estado actual de la solicitud.
     * @param {string} solicitudClave Clave de la solicitud a consultar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getEstadoFormalizacionBySolicitud(solicitudClave: string, options?: any) {
        return SolicitudApiFp(this.configuration).getEstadoFormalizacionBySolicitud(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera una lista con los estados de formalizacion que puede consultar el usuario autenticado
     * @summary Estados de formalizacion que puede consultar el usuario autenticado
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getEstadosFormalizacionByMe(options?: any) {
        return SolicitudApiFp(this.configuration).getEstadosFormalizacionByMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el numero solicitudes
     * @summary Recupera un arreglo con las participaciones que tiene el usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getParticipacionesSolicitudes(options?: any) {
        return SolicitudApiFp(this.configuration).getParticipacionesSolicitudes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la solicitud con la clave especificada
     * @summary Obtiene la solicitud con la clave especificada
     * @param {string} solicitudClave Clave de la solicitud a consultar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getSolicitud(solicitudClave: string, options?: any) {
        return SolicitudApiFp(this.configuration).getSolicitud(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene la última aclaración de la solicitud especificada.
     * @summary Obtiene la última aclaración de la solicitud especificada.
     * @param {string} solicitudClave Clave de la solicitud a consultar
     * @param {0} page Número de la pagina
     * @param {1} size Elementos por página
     * @param {'desc'} sort 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public getUltimaAclaracionBySolicitud(solicitudClave: string, page: 0, size: 1, sort: 'desc', options?: any) {
        return SolicitudApiFp(this.configuration).getUltimaAclaracionBySolicitud(solicitudClave, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rechaza una aclaración abierta
     * @summary Rechaza una aclaración abierta
     * @param {string} aclaracionId El id de la aclaración.
     * @param {Comentario} [comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public rechazaAclaracionBySolicitud(aclaracionId: string, comentario?: Comentario, options?: any) {
        return SolicitudApiFp(this.configuration).rechazaAclaracionBySolicitud(aclaracionId, comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Regenera los firmables de una solicitud, indicando si se borrarán las firmas, solo los usuarios autenticados con el rol de operador, coordinador o director.
     * @summary Regenera los firmables de una solicitud, indicando si se borrarán las firmas
     * @param {string} solicitudId Id de la solicitud a la que pertenecen los firmables a regenerar
     * @param {boolean} deleteFirma Para indicar si se borran las firmas con valor true, en otro caso false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public regeneraFirmables(solicitudId: string, deleteFirma: boolean, options?: any) {
        return SolicitudApiFp(this.configuration).regeneraFirmables(solicitudId, deleteFirma, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Agrega o actualiza la cuenta bancaria asociada a la solicitud dada.
     * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
     * @param {string} solicitudId Id de la solicitud a la que pertenece la cuenta actualizar.
     * @param {ApoyoEconomico} apoyoEconomico Datos del apoyo economico.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public setApoyoEconomicoByParticipacion(solicitudId: string, apoyoEconomico: ApoyoEconomico, options?: any) {
        return SolicitudApiFp(this.configuration).setApoyoEconomicoByParticipacion(solicitudId, apoyoEconomico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Agrega o actualiza la cuenta bancaria asociada al solicitud dada.
     * @summary Agrega o actualiza la cuenta bancaria asociada a la participación.
     * @param {string} solicitudId Id de la solicitud al que pertenece la cuenta actualizar.
     * @param {CuentaBancaria} cuentaBancaria La cuenta bancaria.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public setCuentaBancariaByParticipacion(solicitudId: string, cuentaBancaria: CuentaBancaria, options?: any) {
        return SolicitudApiFp(this.configuration).setCuentaBancariaByParticipacion(solicitudId, cuentaBancaria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza los dependientes económicos de la solicitud dada.
     * @summary Actualiza los dependientes económicos de la participación.
     * @param {string} solicitudId Id de la solicitud a la que pertenece la participación a actualizar.
     * @param {Array<DependienteEconomico>} dependienteEconomico Nueva lista de dependientes económicos.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public updateDependientesEconomicosByMe(solicitudId: string, dependienteEconomico: Array<DependienteEconomico>, options?: any) {
        return SolicitudApiFp(this.configuration).updateDependientesEconomicosByMe(solicitudId, dependienteEconomico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza la solicitud
     * @summary Actualiza la solicitud
     * @param {Solicitud} solicitud Solicitud con los cambios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public updateSolicitud(solicitud: Solicitud, options?: any) {
        return SolicitudApiFp(this.configuration).updateSolicitud(solicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Usado cuando el solicitante está de acuerdo con el contenido de los documentos.
     * @summary Indica que los documentos están validados por parte del solicitante.
     * @param {string} solicitudClave Clave de la solicitud a cambiar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudApi
     */
    public validaDocumentos(solicitudClave: string, options?: any) {
        return SolicitudApiFp(this.configuration).validaDocumentos(solicitudClave, options).then((request) => request(this.axios, this.basePath));
    }

}


